/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0XQZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__3L79g","wrapper":"wrapper__1XlKF","text":"text__3HGiV","next":"next__E_MZR","extra":"extra__3I-CI","heart":"heart__2XNZ2","inView":"inView__1NysS","labelWrap":"labelWrap__2lGQD","label":"label__2vgYO","labelInner":"labelInner__3euB4","vizWrap":"vizWrap__1SdQ7","viz":"viz__NTNbA","vizInner":"vizInner__2K5jF"};

/***/ }),

/***/ "0aRJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__2Iu-q","extra":"extra__3AGNr","viz":"viz__2KgWY","vizInner":"vizInner__2f-FV","ieWrap":"ieWrap__2afSC","imageSizer":"imageSizer__1Xbzh","imageWrap":"imageWrap__3ybaK","wrap":"wrap__joIXC","canvas":"canvas__1uWF-","sections":"sections__2a7md","labels":"labels__27vaj"};

/***/ }),

/***/ "52fv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__3MJvC","grid":"grid__2r7WQ","heart":"heart__2BtKU","sparkle":"sparkle__1Ncr5"};

/***/ }),

/***/ "8C0a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__DiIfB","snug":"snug__1EkJD"};

/***/ }),

/***/ "9qb7":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ "9rP9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__Jgsrz","extra":"extra__2cepb","wrapper":"wrapper__yhMKT","isVisible":"isVisible__3G6fI","override":"override__q31Br","next":"next__IP-O9"};

/***/ }),

/***/ "A8Bg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__XwqXj","logo":"logo__2wWKE","links":"links__z5fNV","shareLink":"shareLink__1qm6Q"};

/***/ }),

/***/ "FWi5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GA8P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__1ZuD9","heart":"heart__3nJ9L","back":"back__32PsL"};

/***/ }),

/***/ "GkNt":
/***/ (function(module, exports) {

/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */

(function (window, document) {
  'use strict';

  // Exits early if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.

  if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

    // Minimal polyfill for Edge 15's lack of `isIntersecting`
    // See: https://github.com/w3c/IntersectionObserver/issues/211
    if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
      Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
        get: function get() {
          return this.intersectionRatio > 0;
        }
      });
    }
    return;
  }

  /**
   * An IntersectionObserver registry. This registry exists to hold a strong
   * reference to IntersectionObserver instances currently observering a target
   * element. Without this registry, instances without another reference may be
   * garbage collected.
   */
  var registry = [];

  /**
   * Creates the global IntersectionObserverEntry constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
   * @param {Object} entry A dictionary of instance properties.
   * @constructor
   */
  function IntersectionObserverEntry(entry) {
    this.time = entry.time;
    this.target = entry.target;
    this.rootBounds = entry.rootBounds;
    this.boundingClientRect = entry.boundingClientRect;
    this.intersectionRect = entry.intersectionRect || getEmptyRect();
    this.isIntersecting = !!entry.intersectionRect;

    // Calculates the intersection ratio.
    var targetRect = this.boundingClientRect;
    var targetArea = targetRect.width * targetRect.height;
    var intersectionRect = this.intersectionRect;
    var intersectionArea = intersectionRect.width * intersectionRect.height;

    // Sets intersection ratio.
    if (targetArea) {
      this.intersectionRatio = intersectionArea / targetArea;
    } else {
      // If area is zero and is intersecting, sets to 1, otherwise to 0
      this.intersectionRatio = this.isIntersecting ? 1 : 0;
    }
  }

  /**
   * Creates the global IntersectionObserver constructor.
   * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
   * @param {Function} callback The function to be invoked after intersection
   *     changes have queued. The function is not invoked if the queue has
   *     been emptied by calling the `takeRecords` method.
   * @param {Object=} opt_options Optional configuration options.
   * @constructor
   */
  function IntersectionObserver(callback, opt_options) {

    var options = opt_options || {};

    if (typeof callback != 'function') {
      throw new Error('callback must be a function');
    }

    if (options.root && options.root.nodeType != 1) {
      throw new Error('root must be an Element');
    }

    // Binds and throttles `this._checkForIntersections`.
    this._checkForIntersections = throttle(this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

    // Private properties.
    this._callback = callback;
    this._observationTargets = [];
    this._queuedEntries = [];
    this._rootMarginValues = this._parseRootMargin(options.rootMargin);

    // Public properties.
    this.thresholds = this._initThresholds(options.threshold);
    this.root = options.root || null;
    this.rootMargin = this._rootMarginValues.map(function (margin) {
      return margin.value + margin.unit;
    }).join(' ');
  }

  /**
   * The minimum interval within which the document will be checked for
   * intersection changes.
   */
  IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;

  /**
   * The frequency in which the polyfill polls for intersection changes.
   * this can be updated on a per instance basis and must be set prior to
   * calling `observe` on the first target.
   */
  IntersectionObserver.prototype.POLL_INTERVAL = null;

  /**
   * Use a mutation observer on the root element
   * to detect intersection changes.
   */
  IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;

  /**
   * Starts observing a target element for intersection changes based on
   * the thresholds values.
   * @param {Element} target The DOM element to observe.
   */
  IntersectionObserver.prototype.observe = function (target) {
    var isTargetAlreadyObserved = this._observationTargets.some(function (item) {
      return item.element == target;
    });

    if (isTargetAlreadyObserved) {
      return;
    }

    if (!(target && target.nodeType == 1)) {
      throw new Error('target must be an Element');
    }

    this._registerInstance();
    this._observationTargets.push({ element: target, entry: null });
    this._monitorIntersections();
    this._checkForIntersections();
  };

  /**
   * Stops observing a target element for intersection changes.
   * @param {Element} target The DOM element to observe.
   */
  IntersectionObserver.prototype.unobserve = function (target) {
    this._observationTargets = this._observationTargets.filter(function (item) {

      return item.element != target;
    });
    if (!this._observationTargets.length) {
      this._unmonitorIntersections();
      this._unregisterInstance();
    }
  };

  /**
   * Stops observing all target elements for intersection changes.
   */
  IntersectionObserver.prototype.disconnect = function () {
    this._observationTargets = [];
    this._unmonitorIntersections();
    this._unregisterInstance();
  };

  /**
   * Returns any queue entries that have not yet been reported to the
   * callback and clears the queue. This can be used in conjunction with the
   * callback to obtain the absolute most up-to-date intersection information.
   * @return {Array} The currently queued entries.
   */
  IntersectionObserver.prototype.takeRecords = function () {
    var records = this._queuedEntries.slice();
    this._queuedEntries = [];
    return records;
  };

  /**
   * Accepts the threshold value from the user configuration object and
   * returns a sorted array of unique threshold values. If a value is not
   * between 0 and 1 and error is thrown.
   * @private
   * @param {Array|number=} opt_threshold An optional threshold value or
   *     a list of threshold values, defaulting to [0].
   * @return {Array} A sorted list of unique and valid threshold values.
   */
  IntersectionObserver.prototype._initThresholds = function (opt_threshold) {
    var threshold = opt_threshold || [0];
    if (!Array.isArray(threshold)) threshold = [threshold];

    return threshold.sort().filter(function (t, i, a) {
      if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
        throw new Error('threshold must be a number between 0 and 1 inclusively');
      }
      return t !== a[i - 1];
    });
  };

  /**
   * Accepts the rootMargin value from the user configuration object
   * and returns an array of the four margin values as an object containing
   * the value and unit properties. If any of the values are not properly
   * formatted or use a unit other than px or %, and error is thrown.
   * @private
   * @param {string=} opt_rootMargin An optional rootMargin value,
   *     defaulting to '0px'.
   * @return {Array<Object>} An array of margin objects with the keys
   *     value and unit.
   */
  IntersectionObserver.prototype._parseRootMargin = function (opt_rootMargin) {
    var marginString = opt_rootMargin || '0px';
    var margins = marginString.split(/\s+/).map(function (margin) {
      var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
      if (!parts) {
        throw new Error('rootMargin must be specified in pixels or percent');
      }
      return { value: parseFloat(parts[1]), unit: parts[2] };
    });

    // Handles shorthand.
    margins[1] = margins[1] || margins[0];
    margins[2] = margins[2] || margins[0];
    margins[3] = margins[3] || margins[1];

    return margins;
  };

  /**
   * Starts polling for intersection changes if the polling is not already
   * happening, and if the page's visibilty state is visible.
   * @private
   */
  IntersectionObserver.prototype._monitorIntersections = function () {
    if (!this._monitoringIntersections) {
      this._monitoringIntersections = true;

      // If a poll interval is set, use polling instead of listening to
      // resize and scroll events or DOM mutations.
      if (this.POLL_INTERVAL) {
        this._monitoringInterval = setInterval(this._checkForIntersections, this.POLL_INTERVAL);
      } else {
        addEvent(window, 'resize', this._checkForIntersections, true);
        addEvent(document, 'scroll', this._checkForIntersections, true);

        if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
          this._domObserver = new MutationObserver(this._checkForIntersections);
          this._domObserver.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }
    }
  };

  /**
   * Stops polling for intersection changes.
   * @private
   */
  IntersectionObserver.prototype._unmonitorIntersections = function () {
    if (this._monitoringIntersections) {
      this._monitoringIntersections = false;

      clearInterval(this._monitoringInterval);
      this._monitoringInterval = null;

      removeEvent(window, 'resize', this._checkForIntersections, true);
      removeEvent(document, 'scroll', this._checkForIntersections, true);

      if (this._domObserver) {
        this._domObserver.disconnect();
        this._domObserver = null;
      }
    }
  };

  /**
   * Scans each observation target for intersection changes and adds them
   * to the internal entries queue. If new entries are found, it
   * schedules the callback to be invoked.
   * @private
   */
  IntersectionObserver.prototype._checkForIntersections = function () {
    var rootIsInDom = this._rootIsInDom();
    var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

    this._observationTargets.forEach(function (item) {
      var target = item.element;
      var targetRect = getBoundingClientRect(target);
      var rootContainsTarget = this._rootContainsTarget(target);
      var oldEntry = item.entry;
      var intersectionRect = rootIsInDom && rootContainsTarget && this._computeTargetAndRootIntersection(target, rootRect);

      var newEntry = item.entry = new IntersectionObserverEntry({
        time: now(),
        target: target,
        boundingClientRect: targetRect,
        rootBounds: rootRect,
        intersectionRect: intersectionRect
      });

      if (!oldEntry) {
        this._queuedEntries.push(newEntry);
      } else if (rootIsInDom && rootContainsTarget) {
        // If the new entry intersection ratio has crossed any of the
        // thresholds, add a new entry.
        if (this._hasCrossedThreshold(oldEntry, newEntry)) {
          this._queuedEntries.push(newEntry);
        }
      } else {
        // If the root is not in the DOM or target is not contained within
        // root but the previous entry for this target had an intersection,
        // add a new record indicating removal.
        if (oldEntry && oldEntry.isIntersecting) {
          this._queuedEntries.push(newEntry);
        }
      }
    }, this);

    if (this._queuedEntries.length) {
      this._callback(this.takeRecords(), this);
    }
  };

  /**
   * Accepts a target and root rect computes the intersection between then
   * following the algorithm in the spec.
   * TODO(philipwalton): at this time clip-path is not considered.
   * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
   * @param {Element} target The target DOM element
   * @param {Object} rootRect The bounding rect of the root after being
   *     expanded by the rootMargin value.
   * @return {?Object} The final intersection rect object or undefined if no
   *     intersection is found.
   * @private
   */
  IntersectionObserver.prototype._computeTargetAndRootIntersection = function (target, rootRect) {

    // If the element isn't displayed, an intersection can't happen.
    if (window.getComputedStyle(target).display == 'none') return;

    var targetRect = getBoundingClientRect(target);
    var intersectionRect = targetRect;
    var parent = getParentNode(target);
    var atRoot = false;

    while (!atRoot) {
      var parentRect = null;
      var parentComputedStyle = parent.nodeType == 1 ? window.getComputedStyle(parent) : {};

      // If the parent isn't displayed, an intersection can't happen.
      if (parentComputedStyle.display == 'none') return;

      if (parent == this.root || parent == document) {
        atRoot = true;
        parentRect = rootRect;
      } else {
        // If the element has a non-visible overflow, and it's not the <body>
        // or <html> element, update the intersection rect.
        // Note: <body> and <html> cannot be clipped to a rect that's not also
        // the document rect, so no need to compute a new intersection.
        if (parent != document.body && parent != document.documentElement && parentComputedStyle.overflow != 'visible') {
          parentRect = getBoundingClientRect(parent);
        }
      }

      // If either of the above conditionals set a new parentRect,
      // calculate new intersection data.
      if (parentRect) {
        intersectionRect = computeRectIntersection(parentRect, intersectionRect);

        if (!intersectionRect) break;
      }
      parent = getParentNode(parent);
    }
    return intersectionRect;
  };

  /**
   * Returns the root rect after being expanded by the rootMargin value.
   * @return {Object} The expanded root rect.
   * @private
   */
  IntersectionObserver.prototype._getRootRect = function () {
    var rootRect;
    if (this.root) {
      rootRect = getBoundingClientRect(this.root);
    } else {
      // Use <html>/<body> instead of window since scroll bars affect size.
      var html = document.documentElement;
      var body = document.body;
      rootRect = {
        top: 0,
        left: 0,
        right: html.clientWidth || body.clientWidth,
        width: html.clientWidth || body.clientWidth,
        bottom: html.clientHeight || body.clientHeight,
        height: html.clientHeight || body.clientHeight
      };
    }
    return this._expandRectByRootMargin(rootRect);
  };

  /**
   * Accepts a rect and expands it by the rootMargin value.
   * @param {Object} rect The rect object to expand.
   * @return {Object} The expanded rect.
   * @private
   */
  IntersectionObserver.prototype._expandRectByRootMargin = function (rect) {
    var margins = this._rootMarginValues.map(function (margin, i) {
      return margin.unit == 'px' ? margin.value : margin.value * (i % 2 ? rect.width : rect.height) / 100;
    });
    var newRect = {
      top: rect.top - margins[0],
      right: rect.right + margins[1],
      bottom: rect.bottom + margins[2],
      left: rect.left - margins[3]
    };
    newRect.width = newRect.right - newRect.left;
    newRect.height = newRect.bottom - newRect.top;

    return newRect;
  };

  /**
   * Accepts an old and new entry and returns true if at least one of the
   * threshold values has been crossed.
   * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
   *    particular target element or null if no previous entry exists.
   * @param {IntersectionObserverEntry} newEntry The current entry for a
   *    particular target element.
   * @return {boolean} Returns true if a any threshold has been crossed.
   * @private
   */
  IntersectionObserver.prototype._hasCrossedThreshold = function (oldEntry, newEntry) {

    // To make comparing easier, an entry that has a ratio of 0
    // but does not actually intersect is given a value of -1
    var oldRatio = oldEntry && oldEntry.isIntersecting ? oldEntry.intersectionRatio || 0 : -1;
    var newRatio = newEntry.isIntersecting ? newEntry.intersectionRatio || 0 : -1;

    // Ignore unchanged ratios
    if (oldRatio === newRatio) return;

    for (var i = 0; i < this.thresholds.length; i++) {
      var threshold = this.thresholds[i];

      // Return true if an entry matches a threshold or if the new ratio
      // and the old ratio are on the opposite sides of a threshold.
      if (threshold == oldRatio || threshold == newRatio || threshold < oldRatio !== threshold < newRatio) {
        return true;
      }
    }
  };

  /**
   * Returns whether or not the root element is an element and is in the DOM.
   * @return {boolean} True if the root element is an element and is in the DOM.
   * @private
   */
  IntersectionObserver.prototype._rootIsInDom = function () {
    return !this.root || containsDeep(document, this.root);
  };

  /**
   * Returns whether or not the target element is a child of root.
   * @param {Element} target The target element to check.
   * @return {boolean} True if the target element is a child of root.
   * @private
   */
  IntersectionObserver.prototype._rootContainsTarget = function (target) {
    return containsDeep(this.root || document, target);
  };

  /**
   * Adds the instance to the global IntersectionObserver registry if it isn't
   * already present.
   * @private
   */
  IntersectionObserver.prototype._registerInstance = function () {
    if (registry.indexOf(this) < 0) {
      registry.push(this);
    }
  };

  /**
   * Removes the instance from the global IntersectionObserver registry.
   * @private
   */
  IntersectionObserver.prototype._unregisterInstance = function () {
    var index = registry.indexOf(this);
    if (index != -1) registry.splice(index, 1);
  };

  /**
   * Returns the result of the performance.now() method or null in browsers
   * that don't support the API.
   * @return {number} The elapsed time since the page was requested.
   */
  function now() {
    return window.performance && performance.now && performance.now();
  }

  /**
   * Throttles a function and delays its executiong, so it's only called at most
   * once within a given time period.
   * @param {Function} fn The function to throttle.
   * @param {number} timeout The amount of time that must pass before the
   *     function can be called again.
   * @return {Function} The throttled function.
   */
  function throttle(fn, timeout) {
    var timer = null;
    return function () {
      if (!timer) {
        timer = setTimeout(function () {
          fn();
          timer = null;
        }, timeout);
      }
    };
  }

  /**
   * Adds an event handler to a DOM node ensuring cross-browser compatibility.
   * @param {Node} node The DOM node to add the event handler to.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to add.
   * @param {boolean} opt_useCapture Optionally adds the even to the capture
   *     phase. Note: this only works in modern browsers.
   */
  function addEvent(node, event, fn, opt_useCapture) {
    if (typeof node.addEventListener == 'function') {
      node.addEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.attachEvent == 'function') {
      node.attachEvent('on' + event, fn);
    }
  }

  /**
   * Removes a previously added event handler from a DOM node.
   * @param {Node} node The DOM node to remove the event handler from.
   * @param {string} event The event name.
   * @param {Function} fn The event handler to remove.
   * @param {boolean} opt_useCapture If the event handler was added with this
   *     flag set to true, it should be set to true here in order to remove it.
   */
  function removeEvent(node, event, fn, opt_useCapture) {
    if (typeof node.removeEventListener == 'function') {
      node.removeEventListener(event, fn, opt_useCapture || false);
    } else if (typeof node.detatchEvent == 'function') {
      node.detatchEvent('on' + event, fn);
    }
  }

  /**
   * Returns the intersection between two rect objects.
   * @param {Object} rect1 The first rect.
   * @param {Object} rect2 The second rect.
   * @return {?Object} The intersection rect or undefined if no intersection
   *     is found.
   */
  function computeRectIntersection(rect1, rect2) {
    var top = Math.max(rect1.top, rect2.top);
    var bottom = Math.min(rect1.bottom, rect2.bottom);
    var left = Math.max(rect1.left, rect2.left);
    var right = Math.min(rect1.right, rect2.right);
    var width = right - left;
    var height = bottom - top;

    return width >= 0 && height >= 0 && {
      top: top,
      bottom: bottom,
      left: left,
      right: right,
      width: width,
      height: height
    };
  }

  /**
   * Shims the native getBoundingClientRect for compatibility with older IE.
   * @param {Element} el The element whose bounding rect to get.
   * @return {Object} The (possibly shimmed) rect of the element.
   */
  function getBoundingClientRect(el) {
    var rect;

    try {
      rect = el.getBoundingClientRect();
    } catch (err) {
      // Ignore Windows 7 IE11 "Unspecified error"
      // https://github.com/w3c/IntersectionObserver/pull/205
    }

    if (!rect) return getEmptyRect();

    // Older IE
    if (!(rect.width && rect.height)) {
      rect = {
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        left: rect.left,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
      };
    }
    return rect;
  }

  /**
   * Returns an empty rect object. An empty rect is returned when an element
   * is not in the DOM.
   * @return {Object} The empty rect.
   */
  function getEmptyRect() {
    return {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: 0,
      height: 0
    };
  }

  /**
   * Checks to see if a parent element contains a child elemnt (including inside
   * shadow DOM).
   * @param {Node} parent The parent element.
   * @param {Node} child The child element.
   * @return {boolean} True if the parent node contains the child node.
   */
  function containsDeep(parent, child) {
    var node = child;
    while (node) {
      if (node == parent) return true;

      node = getParentNode(node);
    }
    return false;
  }

  /**
   * Gets the parent node of an element or its host element if the parent node
   * is a shadow root.
   * @param {Node} node The node whose parent to get.
   * @return {Node|null} The parent node or null if no parent exists.
   */
  function getParentNode(node) {
    var parent = node.parentNode;

    if (parent && parent.nodeType == 11 && parent.host) {
      // If the parent is a shadow root, return the host element.
      return parent.host;
    }
    return parent;
  }

  // Exposes the constructors globally.
  window.IntersectionObserver = IntersectionObserver;
  window.IntersectionObserverEntry = IntersectionObserverEntry;
})(window, document);

/***/ }),

/***/ "HwER":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"main":"main__1Xa6l","inner":"inner__2DA6j"};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./style.css
var style_0 = __webpack_require__("FWi5");
var style_default = /*#__PURE__*/__webpack_require__.n(style_0);

// EXTERNAL MODULE: ../node_modules/smoothscroll-polyfill/dist/smoothscroll.js
var smoothscroll = __webpack_require__("LTbr");
var smoothscroll_default = /*#__PURE__*/__webpack_require__.n(smoothscroll);

// EXTERNAL MODULE: ./components/Header/style.css
var Header_style = __webpack_require__("A8Bg");
var Header_style_default = /*#__PURE__*/__webpack_require__.n(Header_style);

// EXTERNAL MODULE: ./components/Container/style.css
var Container_style = __webpack_require__("8C0a");
var Container_style_default = /*#__PURE__*/__webpack_require__.n(Container_style);

// EXTERNAL MODULE: ../node_modules/classnames/index.js
var classnames = __webpack_require__("9qb7");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./components/Container/index.js




var Container_Container = function Container(_ref) {
	var _cn;

	var children = _ref.children,
	    snug = _ref.snug;
	return Object(preact_min["h"])(
		'div',
		{ className: classnames_default()(Container_style_default.a.root, (_cn = {}, _cn[Container_style_default.a.snug] = snug, _cn)) },
		children
	);
};

/* harmony default export */ var components_Container = (Container_Container);
// EXTERNAL MODULE: ./components/Logo/style.css
var Logo_style = __webpack_require__("h0Qy");
var Logo_style_default = /*#__PURE__*/__webpack_require__.n(Logo_style);

// CONCATENATED MODULE: ./components/Logo/index.js




var Logo__ref2 = Object(preact_min["h"])(
	'svg',
	{
		width: '120px',
		height: '56px',
		viewBox: '0 0 120 56',
		version: '1.1',
		xmlns: 'http://www.w3.org/2000/svg'
	},
	Object(preact_min["h"])(
		'title',
		null,
		'totaljobs'
	),
	Object(preact_min["h"])(
		'g',
		{ stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
		Object(preact_min["h"])(
			'g',
			null,
			Object(preact_min["h"])('path', {
				d: 'M93.3080402,45.6119598 C89.3163317,45.6119598 86.1829146,42.4963819 86.1829146,38.4290452 L86.1829146,26.9998995 L88.7442211,26.9998995 L88.7442211,32.859196 C89.9703518,31.8393467 91.5643216,31.2461307 93.3080402,31.2461307 C97.2997487,31.2461307 100.433166,34.3622111 100.433166,38.4290452 C100.433166,42.4963819 97.2997487,45.6119598 93.3080402,45.6119598 Z M88.7442211,38.4290452 C88.7442211,40.9933668 90.7741206,43.1303015 93.3080402,43.1303015 C95.8419598,43.1303015 97.8718593,40.9933668 97.8718593,38.4290452 C97.8718593,35.8923618 95.8419598,33.7277889 93.3080402,33.7277889 C90.7741206,33.7277889 88.7442211,35.8923618 88.7442211,38.4290452 Z M54.8758794,45.6119598 L52.3148241,45.6119598 L52.3148241,43.9988945 C51.0886935,45.0194975 49.5082915,45.6119598 47.7507538,45.6119598 C43.7590452,45.6119598 40.6256281,42.4963819 40.6256281,38.4290452 C40.6256281,34.3622111 43.7590452,31.2461307 47.7507538,31.2461307 C51.7424623,31.2461307 54.8758794,34.3622111 54.8758794,38.4290452 L54.8758794,45.6119598 Z M43.2005025,38.4290452 C43.2005025,40.9659799 45.230402,43.1303015 47.7643216,43.1303015 C50.2984925,43.1303015 52.328392,40.9659799 52.328392,38.4290452 C52.328392,35.8647236 50.2984925,33.7277889 47.7643216,33.7277889 C45.2168342,33.7277889 43.2005025,35.8647236 43.2005025,38.4290452 Z M105.269598,45.6119598 C107.748995,45.6119598 109.860804,43.7096985 109.860804,41.1453769 C109.860804,39.0084422 108.348492,38.0292965 106.781658,37.3127136 C105.215075,36.5953769 103.675628,36.0715075 103.675628,34.8860804 C103.675628,34.141608 104.356784,33.5624623 105.078894,33.5624623 C105.814573,33.5624623 106.468342,34.0863317 106.781658,34.748392 L108.86608,33.6177387 C108.157789,32.1426131 106.85,31.2599497 105.215075,31.2599497 C103.048995,31.2461307 101.277889,32.9833166 101.277889,35.1757789 C101.277889,37.0227638 102.367839,37.7672362 103.838945,38.5810553 L106.345729,39.9456281 C106.945226,40.3453769 107.28593,40.6901005 107.28593,41.4207538 C107.28593,42.5790452 106.345729,43.3235176 105.25603,43.3235176 C104.029899,43.3235176 103.375879,42.6064322 102.830905,41.5865829 L100.637437,42.5926131 C101.359548,44.4953769 103.334925,45.6119598 105.269598,45.6119598 Z M77.7907035,45.6119598 C73.798995,45.6119598 70.6655779,42.4963819 70.6655779,38.4290452 C70.6655779,34.3622111 73.798995,31.2461307 77.7907035,31.2461307 C81.7824121,31.2461307 84.9158291,34.3622111 84.9158291,38.4290452 C84.9158291,42.4963819 81.7824121,45.6119598 77.7907035,45.6119598 Z M73.2404523,38.4290452 C73.2404523,40.9659799 75.2567839,43.1303015 77.8045226,43.1303015 C80.3384422,43.1303015 82.3683417,40.9659799 82.3683417,38.4290452 C82.3683417,35.8647236 80.3520101,33.7277889 77.8045226,33.7277889 C75.2567839,33.7277889 73.2404523,35.8647236 73.2404523,38.4290452 Z M63.4723618,45.6119598 C68.4859296,45.6119598 69.2896985,41.4071859 69.2896985,37.2159799 L69.2896985,30.6946231 L66.6057789,30.6946231 L66.6057789,37.229799 L66.6057789,37.4639698 C66.6057789,39.6973869 66.5512563,43.0752764 63.581407,43.0752764 C62.818593,43.0752764 62.0419598,42.8132161 61.4424623,42.3446231 L60.0937186,44.6607035 C61.1562814,45.2948744 62.2190955,45.6119598 63.4723618,45.6119598 Z M38.1326633,45.6119598 L38.1326633,33.6865829 L40.639196,33.6865829 L40.639196,31.2599497 L38.1326633,31.2599497 L38.1326633,26.9998995 L35.5713568,26.9998995 L35.5713568,31.2599497 L34.1680905,31.2599497 L34.1680905,33.6865829 L35.5713568,33.6865829 L35.5713568,45.6119598 L38.1326633,45.6119598 Z M26.5253769,45.6119598 C22.5472362,45.6119598 19.4002513,42.4963819 19.4002513,38.4290452 C19.4002513,34.3622111 22.5336683,31.2461307 26.5253769,31.2461307 C30.5170854,31.2461307 33.6505025,34.3622111 33.6505025,38.4290452 C33.6505025,42.4963819 30.5170854,45.6119598 26.5253769,45.6119598 Z M21.9751256,38.4290452 C21.9751256,40.9659799 23.991206,43.1303015 26.5389447,43.1303015 C29.0728643,43.1303015 31.1027638,40.9659799 31.1027638,38.4290452 C31.1027638,35.8647236 29.0864322,33.7277889 26.5389447,33.7277889 C23.991206,33.7277889 21.9751256,35.8647236 21.9751256,38.4290452 Z M17.1251256,45.6119598 C12.1115578,45.6119598 11.3077889,41.4071859 11.3077889,37.2159799 L11.3077889,33.6865829 L10,33.6865829 L10,31.2599497 L11.3213568,31.2599497 L11.3213568,26.9998995 L14.0052764,26.9998995 L14.0052764,31.2599497 L16.4846734,31.2599497 L16.4846734,33.6865829 L13.9917085,33.6865829 L13.9917085,37.229799 L13.9917085,37.4777889 C13.9917085,39.7114573 14.0459799,43.0890955 17.0160804,43.0890955 C17.7788945,43.0890955 18.5555276,42.8270352 19.1550251,42.3584422 L20.4899497,44.6747739 C19.4409548,45.2948744 18.378392,45.6119598 17.1251256,45.6119598 Z M56.5379397,45.5981407 L59.0992462,45.5981407 L59.0992462,26.9998995 L56.5379397,26.9998995 L56.5379397,45.5981407 Z M66.6603015,29.6609548 L69.2896985,29.6609548 L69.2896985,27.0001508 L66.6603015,27.0001508 L66.6603015,29.6609548 Z',
				fill: '#66BD00'
			})
		)
	)
);

var Logo_Logo = function Logo(_ref) {
	var _cn;

	var trim = _ref.trim;
	return Object(preact_min["h"])(
		'a',
		{
			className: classnames_default()(Logo_style_default.a.logo, (_cn = {}, _cn[Logo_style_default.a.trim] = trim, _cn)),
			href: 'https://www.totaljobs.com/insidejob/',
			target: '_blank',
			rel: 'noopener noreferrer'
		},
		Logo__ref2
	);
};

/* harmony default export */ var components_Logo = (Logo_Logo);
// CONCATENATED MODULE: ./components/Header/index.js





var objToHash = function objToHash(obj) {
	return Object.keys(obj).map(function (key) {
		return key + '=' + encodeURIComponent(obj[key]);
	}).join('&');
};

var tweetParams = {
	url: "https://total-jobs-love.beyondwordsstudio.com",
	text: 'Would you ever date a colleague? And which job offers the best chance of a date? Discover the secrets of the UK’s workplace romances with @totaljobsuk.'
};

var fbParams = {
	u: "https://total-jobs-love.beyondwordsstudio.com"
};

var Header__ref = Object(preact_min["h"])(components_Logo, null);

var Header__ref2 = Object(preact_min["h"])(
	'svg',
	{
		width: 15,
		height: 15,
		viewBox: '0 0 25 25',
		fill: 'currentColor'
	},
	Object(preact_min["h"])(
		'title',
		null,
		'Share on Twitter'
	),
	Object(preact_min["h"])('path', { d: 'M22.05 5.17a5.38 5.38 0 0 0 2.26-3 9.88 9.88 0 0 1-3.26 1.31 5 5 0 0 0-3.74-1.7 5.27 5.27 0 0 0-5.13 5.4 5.61 5.61 0 0 0 .13 1.24A14.33 14.33 0 0 1 1.74 2.77a5.67 5.67 0 0 0-.69 2.73A5.48 5.48 0 0 0 3.33 10 4.94 4.94 0 0 1 1 9.32v.07a5.34 5.34 0 0 0 4.12 5.3 4.64 4.64 0 0 1-1.35.19 5.15 5.15 0 0 1-1-.09 5.16 5.16 0 0 0 4.79 3.75 9.89 9.89 0 0 1-6.37 2.32A8.24 8.24 0 0 1 0 20.78a14 14 0 0 0 7.86 2.43c9.44 0 14.59-8.24 14.59-15.39v-.7A10.71 10.71 0 0 0 25 4.32a9.83 9.83 0 0 1-2.95.85z' })
);

var Header__ref3 = Object(preact_min["h"])(
	'svg',
	{
		width: 15,
		height: 15,
		viewBox: '0 0 25 25',
		fill: 'currentColor'
	},
	Object(preact_min["h"])(
		'title',
		null,
		'Share on Facebook'
	),
	Object(preact_min["h"])('path', { d: 'M14.47 25h-5.3V12.5H6.52V8.19h2.65V5.6c0-3.51 1.5-5.6 5.75-5.6h3.53v4.31h-2.21c-1.65 0-1.76.6-1.76 1.72v2.16h4L18 12.5h-3.53V25z' })
);

var Header_Header = function Header() {
	return Object(preact_min["h"])(
		'div',
		{ className: Header_style_default.a.root },
		Object(preact_min["h"])(
			components_Container,
			{ snug: true },
			Object(preact_min["h"])(
				'div',
				{ className: Header_style_default.a.logo },
				Header__ref
			),
			Object(preact_min["h"])(
				'div',
				{ className: Header_style_default.a.links },
				Object(preact_min["h"])(
					'a',
					{
						className: Header_style_default.a.shareLink,
						href: 'https://twitter.com/share?' + objToHash(tweetParams),
						target: '_blank',
						rel: 'noopener'
					},
					Header__ref2
				),
				Object(preact_min["h"])(
					'a',
					{
						className: Header_style_default.a.shareLink,
						href: 'https://www.facebook.com/sharer/sharer.php?' + objToHash(fbParams),
						target: '_blank',
						rel: 'noopener'
					},
					Header__ref3
				)
			)
		)
	);
};

/* harmony default export */ var components_Header = (Header_Header);
// EXTERNAL MODULE: ./components/Footer/style.css
var Footer_style = __webpack_require__("n4o+");
var Footer_style_default = /*#__PURE__*/__webpack_require__.n(Footer_style);

// CONCATENATED MODULE: ./components/Footer/index.js





var Footer__ref = Object(preact_min["h"])(components_Logo, { trim: true });

var Footer__ref2 = Object(preact_min["h"])(
	'p',
	null,
	Object(preact_min["h"])(
		'strong',
		null,
		'Survey data'
	),
	' ',
	Object(preact_min["h"])('br', null),
	'Totaljobs research of 5,795 UK workers in Febuary 2018.'
);

var Footer_Footer = function Footer() {
	return Object(preact_min["h"])(
		'div',
		{ className: Footer_style_default.a.root },
		Object(preact_min["h"])(
			components_Container,
			null,
			Object(preact_min["h"])(
				'p',
				{ className: Footer_style_default.a.logo },
				Footer__ref
			),
			Footer__ref2
		)
	);
};

/* harmony default export */ var components_Footer = (Footer_Footer);
// EXTERNAL MODULE: ./layouts/main/style.css
var main_style = __webpack_require__("HwER");
var main_style_default = /*#__PURE__*/__webpack_require__.n(main_style);

// CONCATENATED MODULE: ./layouts/main/index.js





var main__ref2 = Object(preact_min["h"])(components_Header, null);

var main__ref3 = Object(preact_min["h"])(components_Footer, null);

var main_Main = function Main(_ref) {
	var children = _ref.children;
	return Object(preact_min["h"])(
		'div',
		{ className: main_style_default.a.main },
		Object(preact_min["h"])(
			'div',
			{ className: main_style_default.a.header },
			main__ref2
		),
		Object(preact_min["h"])(
			'main',
			{ className: main_style_default.a.inner },
			children
		),
		Object(preact_min["h"])(
			'div',
			{ className: main_style_default.a.footer },
			main__ref3
		)
	);
};

/* harmony default export */ var layouts_main = (main_Main);
// EXTERNAL MODULE: ./components/Intro/style.css
var Intro_style = __webpack_require__("l8Hw");
var Intro_style_default = /*#__PURE__*/__webpack_require__.n(Intro_style);

// EXTERNAL MODULE: ./components/NextArrow/style.css
var NextArrow_style = __webpack_require__("GA8P");
var NextArrow_style_default = /*#__PURE__*/__webpack_require__.n(NextArrow_style);

// CONCATENATED MODULE: ./components/NextArrow/index.js



var scrollTo = function scrollTo(e, id) {
	var block = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'start';

	e.preventDefault();
	document.getElementById(id).scrollIntoView({
		block: block,
		behavior: 'smooth'
	});
};

var NextArrow__ref2 = Object(preact_min["h"])(
	'title',
	null,
	'Next section'
);

var NextArrow__ref3 = Object(preact_min["h"])(
	'g',
	{ stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
	Object(preact_min["h"])(
		'g',
		{ stroke: '#000000' },
		Object(preact_min["h"])('circle', { cx: '20', cy: '20', r: '19.5' }),
		Object(preact_min["h"])('path', {
			fill: 'transparent',
			stroke: 'rgba(0, 0, 0, 0.2)',
			d: 'M20,13.716 C17.712,11.428 14.003,11.428 11.716,13.716 C9.73595207,15.6960479 9.46944864,18.7403208 10.9164897,21.0061981 C11.1415445,21.3586046 11.4080479,21.6921825 11.716,22 L20,30.284 L28.284,22 C28.5915952,21.6925393 28.8578377,21.3593778 29.0827276,21.0074234 C30.5306474,18.7414183 30.2644048,15.6964048 28.284,13.716 C25.996,11.428 22.287,11.428 20,13.716 Z',
			'stroke-linecap': 'round',
			'stroke-linejoin': 'round'
		}),
		Object(preact_min["h"])('polyline', {
			'stroke-linecap': 'round',
			'stroke-linejoin': 'round',
			points: '11.75 22 20.034 30.284 28.318 22'
		})
	)
);

var _ref4 = Object(preact_min["h"])(
	'svg',
	{
		width: '40px',
		height: '40px',
		viewBox: '0 0 40 40',
		version: '1.1',
		xmlns: 'http://www.w3.org/2000/svg'
	},
	Object(preact_min["h"])('path', {
		fill: '#e74347',
		stroke: '#000',
		d: 'M20,13.716 C17.712,11.428 14.003,11.428 11.716,13.716 C9.73595207,15.6960479 9.46944864,18.7403208 10.9164897,21.0061981 C11.1415445,21.3586046 11.4080479,21.6921825 11.716,22 L20,30.284 L28.284,22 C28.5915952,21.6925393 28.8578377,21.3593778 29.0827276,21.0074234 C30.5306474,18.7414183 30.2644048,15.6964048 28.284,13.716 C25.996,11.428 22.287,11.428 20,13.716 Z',
		'stroke-linecap': 'round',
		'stroke-linejoin': 'round'
	})
);

var NextArrow_NextArrow = function NextArrow(_ref) {
	var to = _ref.to,
	    center = _ref.center;
	return Object(preact_min["h"])(
		'a',
		{ href: '#' + to, className: NextArrow_style_default.a.root, onClick: function onClick(e) {
				return scrollTo(e, to, center);
			} },
		Object(preact_min["h"])(
			'div',
			null,
			Object(preact_min["h"])(
				'svg',
				{
					width: '40px',
					height: '40px',
					viewBox: '0 0 40 40',
					version: '1.1',
					xmlns: 'http://www.w3.org/2000/svg',
					className: NextArrow_style_default.a.front
				},
				NextArrow__ref2,
				NextArrow__ref3
			)
		),
		Object(preact_min["h"])(
			'div',
			{ className: NextArrow_style_default.a.back },
			_ref4
		)
	);
};

/* harmony default export */ var components_NextArrow = (NextArrow_NextArrow);
// EXTERNAL MODULE: ./components/LoveHeart/style.css
var LoveHeart_style = __webpack_require__("52fv");
var LoveHeart_style_default = /*#__PURE__*/__webpack_require__.n(LoveHeart_style);

// CONCATENATED MODULE: ./components/LoveHeart/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var styles = [{ border: '#FECA98', fill: '#FFF2E6' }, { border: '#F1979A', fill: '#F6C1C2' }, { border: '#D8AC24', fill: '#FEE077' }, { border: '#709EEB', fill: '#C2D6F7' }];

var LoveHeart__ref = Object(preact_min["h"])('use', { xlinkHref: '#sparkle' });

var LoveHeart_LoveHeart = function (_Component) {
	_inherits(LoveHeart, _Component);

	function LoveHeart() {
		_classCallCheck(this, LoveHeart);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	LoveHeart.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		return this.props.x !== nextProps.x || this.props.y !== nextProps.y;
	};

	LoveHeart.prototype.render = function render() {
		var _props = this.props,
		    text = _props.text,
		    text2 = _props.text2,
		    x = _props.x,
		    y = _props.y,
		    id = _props.id,
		    style = _props.style,
		    rotation = _props.rotation,
		    isSmall = _props.isSmall,
		    isSparkle = _props.isSparkle,
		    rest = _objectWithoutProperties(_props, ['text', 'text2', 'x', 'y', 'id', 'style', 'rotation', 'isSmall', 'isSparkle']);

		var colors = styles[style - 1];

		return Object(preact_min["h"])(
			'div',
			_extends({}, rest, {
				className: LoveHeart_style_default.a.root,
				style: {
					transform: 'translate(' + x + 'px, ' + y + 'px) scale(' + (isSmall ? 0.75 : 1) + ')',
					zIndex: isSparkle ? 1 : 2
				}
			}),
			isSparkle && Object(preact_min["h"])(
				'svg',
				{
					width: '16px',
					height: '16px',
					viewBox: '0 0 8 8',
					className: LoveHeart_style_default.a.sparkle,
					style: {
						transform: 'rotate(' + rotation + 'deg)',
						animationDelay: id * -0.11 + 's'
					}
				},
				LoveHeart__ref
			),
			!isSparkle && Object(preact_min["h"])(
				'svg',
				{
					className: LoveHeart_style_default.a.heart,
					width: '70px',
					height: '70px',
					style: {
						transform: 'rotate(' + rotation + 'deg)'
					}
				},
				Object(preact_min["h"])('use', {
					xlinkHref: '#heart',
					style: {
						fill: colors.fill,
						color: colors.border
					}
				}),
				Object(preact_min["h"])(
					'text',
					{
						'font-size': '10',
						'font-weight': 'bold',
						'text-anchor': 'middle',
						fill: '#333'
					},
					Object(preact_min["h"])(
						'tspan',
						{ x: '35', y: '30' },
						text
					),
					Object(preact_min["h"])(
						'tspan',
						{ x: '35', y: '42' },
						text2
					)
				)
			)
		);
	};

	return LoveHeart;
}(preact_min["Component"]);

/* harmony default export */ var components_LoveHeart = (LoveHeart_LoveHeart);
// CONCATENATED MODULE: ./components/Intro/index.js
var Intro__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function Intro__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Intro__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Intro__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var _ref5 = Object(preact_min["h"])(
	'title',
	null,
	'How love works \u2013\xA0The secrets of the UK\'s workplace romances'
);

var _ref6 = Object(preact_min["h"])('path', {
	d: 'M286 300.1l-10.2-15.4a5.6 5.6 0 0 1 0-6.2L286 263a115.8 115.8 0 0 1-45.8-8.9v37.2a116.2 116.2 0 0 0 45.8 8.8z',
	fill: '#ffdfc1'
});

var _ref7 = Object(preact_min["h"])('path', {
	fill: '#feb36c',
	d: 'M266.7 273.5l-26.4 18v-38.7l26.4-17.9v38.6z'
});

var _ref8 = Object(preact_min["h"])('path', {
	d: 'M14 234.6l10.4-15.4a5.6 5.6 0 0 0 0-6.3L14 197.5a116 116 0 0 0 45.7-9v37.2a115.8 115.8 0 0 1-45.7 9z',
	fill: '#ffdfc1'
});

var _ref9 = Object(preact_min["h"])('path', {
	fill: '#feb36c',
	d: 'M33.4 208l26.4 17.9v-38.6l-26.4-18V208zm36.9 7.7l224-46.5v38.6l-224 46.3v-38.4z'
});

var _ref10 = Object(preact_min["h"])('path', {
	d: 'M303 30.2a93 93 0 0 0-139.2 2.4 93 93 0 1 0-133.5 129l133.5 129.5 133.5-129.5A93 93 0 0 0 303 30.2z',
	fill: '#e74347'
});

var _ref11 = Object(preact_min["h"])('path', {
	d: 'M33.4 207.8a169.9 169.9 0 0 1 130.5 0 169.9 169.9 0 0 0 130.4 0v-38.5a169.9 169.9 0 0 1-130.4 0 169.8 169.8 0 0 0-130.5 0z',
	fill: '#feca98'
});

var _ref12 = Object(preact_min["h"])('path', {
	d: 'M70.3 254.1a169.7 169.7 0 0 1 93.6 10.7 169.8 169.8 0 0 0 102.8 8.7v-38.4a169.8 169.8 0 0 1-102.9-8.8 169.7 169.7 0 0 0-93.6-10.6',
	fill: '#feca98'
});

var _ref13 = Object(preact_min["h"])('path', {
	d: 'M286.1 300l-10.3-15.5a5.6 5.6 0 0 1 0-6.2l10.3-15.5a116.1 116.1 0 0 1-45.7-8.9v37.2A116 116 0 0 0 286 300z',
	fill: '#ffdfc1'
});

var _ref14 = Object(preact_min["h"])('path', {
	fill: '#feb36c',
	d: 'M266.8 273.3l-26.4 18v-38.7l26.4-17.9v38.6z'
});

var _ref15 = Object(preact_min["h"])('path', {
	d: 'M14 234.4l10.3-15.5a5.6 5.6 0 0 0 0-6.2L14 197.3a116 116 0 0 0 45.8-9v37.2a116 116 0 0 1-45.8 8.9z',
	fill: '#ffdfc1'
});

var _ref16 = Object(preact_min["h"])('path', {
	fill: '#feb36c',
	d: 'M33.4 207.8l26.4 17.9v-38.6l-26.4-18v38.7zm36.8 7.6l224.2-46.5v38.7L70.2 253.9v-38.5z'
});

var _ref17 = Object(preact_min["h"])('path', {
	d: 'M303 30a93 93 0 0 0-131.4-5.7 94.4 94.4 0 0 0-7.8 8 94.4 94.4 0 0 0-7.7-8 93 93 0 0 0-125.9 137L163.8 291l133.6-129.7A93 93 0 0 0 303 30z',
	fill: '#e74347'
});

var _ref18 = Object(preact_min["h"])('path', {
	d: 'M33.4 207.6a170 170 0 0 1 130.5 0 170 170 0 0 0 130.5 0V169a170 170 0 0 1-130.5 0 170 170 0 0 0-130.6 0z',
	fill: '#feca98'
});

var _ref19 = Object(preact_min["h"])('path', { d: 'M77.6 180.2a1.9 1.9 0 0 0 .1.4.5.5 0 0 0 .2.3.4.4 0 0 0 .2 0 1.3 1.3 0 0 0 .3 0h.6l.1.7-4.8.7v-.8h.5l.3-.1a.5.5 0 0 0 .2-.2.6.6 0 0 0 .1-.3 2 2 0 0 0 0-.4l-1-7.5-1.1.2a1.6 1.6 0 0 0-.5.1.9.9 0 0 0-.3.3.7.7 0 0 0-.2.3 2 2 0 0 0 0 .4v.9l-1 .1-.2-2.7 8.6-1.1.5 2.7h-1l-.2-.8a2 2 0 0 0-.1-.4.8.8 0 0 0-.3-.3 1 1 0 0 0-.3-.1 2 2 0 0 0-.6 0l-1 .1zm9.6.7l-.1-.8h.6a.8.8 0 0 0 .3-.1.4.4 0 0 0 .2-.1.6.6 0 0 0 .1-.3 1.4 1.4 0 0 0 0-.5l-.2-3.1-3.6.3.2 3a1.4 1.4 0 0 0 0 .6.7.7 0 0 0 .3.2.7.7 0 0 0 .2.1h.9v.8l-4.8.3v-.7h.5a1.2 1.2 0 0 0 .3 0 .5.5 0 0 0 .2-.2.6.6 0 0 0 .2-.3 1.4 1.4 0 0 0 0-.5l-.5-6.8a1.2 1.2 0 0 0 0-.4.6.6 0 0 0-.3-.3.5.5 0 0 0-.2 0 1.2 1.2 0 0 0-.3 0h-.6v-.8l4.8-.3v.7H85a1.3 1.3 0 0 0-.3.1.4.4 0 0 0-.2.1.7.7 0 0 0-.2.3 1.4 1.4 0 0 0 0 .5l.2 2.7 3.7-.3-.2-2.7a2.3 2.3 0 0 0-.1-.4.8.8 0 0 0-.2-.3.5.5 0 0 0-.2-.1h-1v-.8l4.8-.3v.7h-.6a.8.8 0 0 0-.2 0 .4.4 0 0 0-.3.2.6.6 0 0 0 0 .3 1.4 1.4 0 0 0 0 .5l.4 6.7a1.1 1.1 0 0 0 0 .5.6.6 0 0 0 .3.2.5.5 0 0 0 .2.1 1.2 1.2 0 0 0 .3 0h.5l.1.7zm8.8-1.2h2.8a.8.8 0 0 0 .4-.1.7.7 0 0 0 .2-.3 1 1 0 0 0 .2-.3 1.8 1.8 0 0 0 0-.4l.2-.7h1v2.6h-8.3v-.6h.5a1.1 1.1 0 0 0 .3 0 .5.5 0 0 0 .2-.2.4.4 0 0 0 .2-.2 1.4 1.4 0 0 0 0-.5l-.1-6.7a1.6 1.6 0 0 0 0-.5.7.7 0 0 0-.2-.3.5.5 0 0 0-.3-.1 1.3 1.3 0 0 0-.2 0h-.6v-.7l7.7-.1.1 2.5h-1v-.6a1.6 1.6 0 0 0-.3-.8.8.8 0 0 0-.7-.3h-2.3v3.5h3.3v.9h-3.3zm12.2 1.2a5.7 5.7 0 0 1-1.6-.3 3 3 0 0 1-1-.5 1.8 1.8 0 0 1-.5-.6 1.6 1.6 0 0 1-.1-.7 1.2 1.2 0 0 1 .2-.6 1 1 0 0 1 .3-.4 1.5 1.5 0 0 1 .6-.2 2.9 2.9 0 0 1 .5 0 3.5 3.5 0 0 0 .1 1 2.1 2.1 0 0 0 .4.8 1.6 1.6 0 0 0 .6.5 2 2 0 0 0 .7.2 2.5 2.5 0 0 0 .7 0 1.7 1.7 0 0 0 .6-.3 1.4 1.4 0 0 0 .4-.5 1.5 1.5 0 0 0 .1-.6 1.3 1.3 0 0 0 0-.6 1.5 1.5 0 0 0-.5-.6 3.7 3.7 0 0 0-.7-.5l-1-.5a8.4 8.4 0 0 1-1.2-.7 3.6 3.6 0 0 1-.7-.7 2.3 2.3 0 0 1-.4-.8 3.2 3.2 0 0 1-.1-1 2.6 2.6 0 0 1 .3-1.1 2.7 2.7 0 0 1 .8-.9 3.6 3.6 0 0 1 1.1-.5 4.8 4.8 0 0 1 1.4-.1 5.9 5.9 0 0 1 1.3.2 3 3 0 0 1 1 .4 1.6 1.6 0 0 1 .4.6 1.4 1.4 0 0 1 .2.6 1 1 0 0 1-.2.5 1 1 0 0 1-.3.3 1.7 1.7 0 0 1-.6.2 3.5 3.5 0 0 1-.7 0 3.6 3.6 0 0 0 0-.6 2.3 2.3 0 0 0-.2-.7 1.6 1.6 0 0 0-.5-.5 1.2 1.2 0 0 0-.6-.2 1.6 1.6 0 0 0-.6 0 1 1 0 0 0-.4.3 1.2 1.2 0 0 0-.4.4 1.5 1.5 0 0 0-.1.5 1.5 1.5 0 0 0 0 .6 1.4 1.4 0 0 0 .4.5 3 3 0 0 0 .7.5 9.8 9.8 0 0 0 1 .6 9 9 0 0 1 1.3.7 4 4 0 0 1 .8.7 2.2 2.2 0 0 1 .4.8 3 3 0 0 1-.3 2.2 2.7 2.7 0 0 1-.8.9 3.6 3.6 0 0 1-1.2.6 5.3 5.3 0 0 1-1.6.1zm8.2-.3l2.8.3a.7.7 0 0 0 .4 0 .7.7 0 0 0 .3-.2 1.2 1.2 0 0 0 .2-.3 2.6 2.6 0 0 0 .1-.4l.2-.7 1 .2-.4 2.5-8.2-1 .1-.7.6.1h.3a.5.5 0 0 0 .2 0 .6.6 0 0 0 .2-.3 1.3 1.3 0 0 0 .1-.4l.8-6.8a1.3 1.3 0 0 0 0-.5.6.6 0 0 0-.1-.2.4.4 0 0 0-.3-.2 1 1 0 0 0-.2 0l-.6-.1v-.8l7.8 1-.2 2.5-1-.1v-.7a1.5 1.5 0 0 0-.2-.8.7.7 0 0 0-.6-.3l-2.4-.3-.3 3.5 3.3.3-.1.9-3.3-.4zm10.9 1.4a3.2 3.2 0 0 0 1.6-.1 3.2 3.2 0 0 0 .6-.4 5.3 5.3 0 0 0 .5-.4.6.6 0 0 1 .2.3 1 1 0 0 1 0 .4 1.3 1.3 0 0 1-.3.5 1.6 1.6 0 0 1-.6.5 3 3 0 0 1-1 .3 5.4 5.4 0 0 1-1.5 0 5.7 5.7 0 0 1-2-.8 4 4 0 0 1-1.3-1.2 4.3 4.3 0 0 1-.6-1.8 6.6 6.6 0 0 1 0-2.1 6.4 6.4 0 0 1 .6-2 4.4 4.4 0 0 1 1.2-1.5 4.2 4.2 0 0 1 1.6-.8 5.6 5.6 0 0 1 2.2 0 6.8 6.8 0 0 1 1.3.4 3.4 3.4 0 0 1 1 .5 1.7 1.7 0 0 1 .4.6 1.3 1.3 0 0 1 .1.7 1 1 0 0 1-.2.4 1.2 1.2 0 0 1-.3.4 1.9 1.9 0 0 1-.6.1 2.8 2.8 0 0 1-.8 0 3.2 3.2 0 0 0 0-.7 1.8 1.8 0 0 0-.1-.6 1.5 1.5 0 0 0-.4-.6 1.4 1.4 0 0 0-.7-.3 2 2 0 0 0-2 .8 4.3 4.3 0 0 0-.6 1.3 11.4 11.4 0 0 0-.5 1.7 9 9 0 0 0-.1 1.8 3.7 3.7 0 0 0 .3 1.3 2.1 2.1 0 0 0 .7.9 3 3 0 0 0 1.3.4zm3.4.8l.6.2h.3a.5.5 0 0 0 .2-.1.5.5 0 0 0 .2-.2 1.4 1.4 0 0 0 .2-.4l1.5-6.7a1.5 1.5 0 0 0 0-.4.6.6 0 0 0-.1-.3.4.4 0 0 0-.2-.2 1.1 1.1 0 0 0-.3 0l-.5-.2.1-.7 4.4 1a5 5 0 0 1 2.7 1.3 2.2 2.2 0 0 1 .5 2 2.8 2.8 0 0 1-.4 1 2.4 2.4 0 0 1-.6.6 3 3 0 0 1-.7.4 4.5 4.5 0 0 1-.7.2l1 3.2a4.7 4.7 0 0 0 .2.6 2.7 2.7 0 0 0 .2.4 1 1 0 0 0 .3.3 1 1 0 0 0 .4.1l-.1.7h-.5a10.4 10.4 0 0 1-1-.4 3 3 0 0 1-.8-.3 2 2 0 0 1-.5-.5 3 3 0 0 1-.3-.8l-1-3.3-.9-.2-.6 2.6a1.5 1.5 0 0 0 0 .5.5.5 0 0 0 .3.4l.3.1.5.2-.1.7-4.7-1.1zm4.4-3.5l.8.2a2.1 2.1 0 0 0 .8 0 1.1 1.1 0 0 0 .6-.2 1.6 1.6 0 0 0 .4-.6 4.1 4.1 0 0 0 .3-.8 4 4 0 0 0 .1-1 1.5 1.5 0 0 0-.2-.6 1.2 1.2 0 0 0-.4-.5 2.6 2.6 0 0 0-.7-.2l-.8-.2zm8.5 6.6l2.7.7a.8.8 0 0 0 .3 0 .8.8 0 0 0 .3-.1 1.3 1.3 0 0 0 .3-.3 2 2 0 0 0 .2-.4l.3-.6 1 .3-.9 2.4-7.8-2.2.2-.7.6.2h.2a.5.5 0 0 0 .3 0 .5.5 0 0 0 .2-.2 1.3 1.3 0 0 0 .2-.4l1.9-6.5a2.1 2.1 0 0 0 0-.5.7.7 0 0 0 0-.3.6.6 0 0 0-.2-.2 1.7 1.7 0 0 0-.3-.1l-.6-.2.3-.7 7.4 2.1-.6 2.5-1-.2.1-.7a1.6 1.6 0 0 0 0-.8.8.8 0 0 0-.5-.5l-2.3-.6-1 3.4 3.2.9-.2.8-3.2-1zm10.4 2.4a1.4 1.4 0 0 0-.1.5.6.6 0 0 0 0 .3.4.4 0 0 0 .2.2 1.5 1.5 0 0 0 .3.1l.5.2-.2.7-4.6-1.6.3-.7.5.2a1.1 1.1 0 0 0 .3.1.5.5 0 0 0 .3 0 .6.6 0 0 0 .2-.3 2 2 0 0 0 .2-.4l2.4-7-1-.4a1.6 1.6 0 0 0-.5-.1 1 1 0 0 0-.4 0 .8.8 0 0 0-.3.3 2 2 0 0 0-.2.3l-.4.8-1-.3 1-2.5 8.3 2.8-.8 2.6-.9-.3.2-.9a1.6 1.6 0 0 0 0-.4.7.7 0 0 0 0-.3 1 1 0 0 0-.3-.3 1.8 1.8 0 0 0-.5-.3l-1-.3zm5.9 4.1a5.7 5.7 0 0 1-1.4-.7 3.1 3.1 0 0 1-.8-.8 1.6 1.6 0 0 1-.2-.8 1.6 1.6 0 0 1 0-.7 1.3 1.3 0 0 1 .4-.5 1 1 0 0 1 .5-.2 1.4 1.4 0 0 1 .6 0 3 3 0 0 1 .5.1 3.4 3.4 0 0 0-.2 1 2.1 2.1 0 0 0 0 .9 1.6 1.6 0 0 0 .4.6 1.9 1.9 0 0 0 .7.4 2 2 0 0 0 .7.2 1.6 1.6 0 0 0 .7 0 1.5 1.5 0 0 0 .5-.4 1.5 1.5 0 0 0 .3-.5 1.5 1.5 0 0 0 0-.7 1.7 1.7 0 0 0-.1-.6 3.6 3.6 0 0 0-.5-.7l-.8-.8a8.8 8.8 0 0 1-.9-1 3.5 3.5 0 0 1-.5-1 2.5 2.5 0 0 1-.1-.8 3.3 3.3 0 0 1 .2-1 2.6 2.6 0 0 1 .7-1 2.7 2.7 0 0 1 1-.5 3.5 3.5 0 0 1 1.2-.2 5 5 0 0 1 1.4.4 6.9 6.9 0 0 1 1.2.6 3.2 3.2 0 0 1 .7.7 1.6 1.6 0 0 1 .3.6 1.3 1.3 0 0 1 0 .7 1.4 1.4 0 0 1-.3.4 1.2 1.2 0 0 1-.5.2 1.6 1.6 0 0 1-.6 0 2.9 2.9 0 0 1-.7-.2 2.8 2.8 0 0 0 .2-.6 2.2 2.2 0 0 0 0-.7 1.4 1.4 0 0 0-.3-.6 1.1 1.1 0 0 0-.6-.4 1.6 1.6 0 0 0-.5-.2 1 1 0 0 0-.5.1 1.1 1.1 0 0 0-.4.3 1.3 1.3 0 0 0-.3.4 1.4 1.4 0 0 0 0 1.2 3.8 3.8 0 0 0 .5.7 10 10 0 0 0 .8 1 9.7 9.7 0 0 1 1 1 4 4 0 0 1 .5.9 2 2 0 0 1 .1.9 2.7 2.7 0 0 1-.2.9 3 3 0 0 1-.7 1 2.7 2.7 0 0 1-1 .6 3.7 3.7 0 0 1-1.4.2 5.3 5.3 0 0 1-1.6-.4zM179 194a7 7 0 0 1-1 2 4.7 4.7 0 0 1-1.4 1.2 4 4 0 0 1-1.7.5 5.2 5.2 0 0 1-2-.3 5.7 5.7 0 0 1-1.9-1 3.9 3.9 0 0 1-1-1.5 4.3 4.3 0 0 1-.4-1.8 7.6 7.6 0 0 1 1.4-4 4.3 4.3 0 0 1 1.3-1.2 3.8 3.8 0 0 1 1.8-.5 5.5 5.5 0 0 1 2 .3 5 5 0 0 1 1.9 1 3.9 3.9 0 0 1 1 1.5 4.5 4.5 0 0 1 .4 1.8 7.2 7.2 0 0 1-.4 2zm-6.8-2.2a10.2 10.2 0 0 0-.4 1.7 4.2 4.2 0 0 0 0 1.4 2.1 2.1 0 0 0 .4 1 2.3 2.3 0 0 0 2.1.7 2.1 2.1 0 0 0 1-.5 4.2 4.2 0 0 0 .8-1.2 11.5 11.5 0 0 0 .7-1.6 12 12 0 0 0 .5-1.8 4.4 4.4 0 0 0 0-1.3 2 2 0 0 0-1.4-1.7 2 2 0 0 0-1.1 0 2.1 2.1 0 0 0-1 .5 4.5 4.5 0 0 0-.9 1 10.8 10.8 0 0 0-.6 1.8zm15.2 2.1l.1-.7a1.2 1.2 0 0 0 0-.9 1 1 0 0 0-.7-.4l-2.1-.6-1 3.7 3.2.9-.3.8-3.2-.9-.7 2.7a2 2 0 0 0 0 .5.7.7 0 0 0 0 .3.4.4 0 0 0 .2.2 1 1 0 0 0 .2.1l.9.2-.2.8-5-1.4.3-.7.5.1a1.5 1.5 0 0 0 .3 0 .5.5 0 0 0 .3 0 .6.6 0 0 0 .2-.2 1.8 1.8 0 0 0 .1-.4l1.8-6.5a1.4 1.4 0 0 0 .1-.5.5.5 0 0 0-.3-.5 1.6 1.6 0 0 0-.2 0l-.6-.2.2-.7 7.5 2-.6 2.5zm9.2 7.9a1.7 1.7 0 0 0 0 .5.5.5 0 0 0 .1.3.5.5 0 0 0 .2.1 1 1 0 0 0 .3.1l.6.1-.2.8-4.7-1 .1-.7.6.1a1 1 0 0 0 .3 0 .4.4 0 0 0 .2 0 .6.6 0 0 0 .2-.3 1.7 1.7 0 0 0 .2-.5l1.4-7.3-1-.2a1.7 1.7 0 0 0-.6 0 1 1 0 0 0-.4.1 1 1 0 0 0-.3.3 1.8 1.8 0 0 0-.1.4l-.3.8-1-.2.7-2.6 8.6 1.7-.5 2.6-1-.1.1-1a2 2 0 0 0 0-.4.8.8 0 0 0-.1-.3.9.9 0 0 0-.3-.3 1.7 1.7 0 0 0-.5-.1l-1.1-.2zm9.6 3.2v-.7h.7a1 1 0 0 0 .3 0 .5.5 0 0 0 .2 0 .7.7 0 0 0 .2-.3 2 2 0 0 0 .1-.5l.4-3-3.6-.6-.4 3.1a1.5 1.5 0 0 0 0 .5.7.7 0 0 0 0 .3.7.7 0 0 0 .3.2h.3l.6.1-.1.8-4.8-.7v-.7h1a.5.5 0 0 0 .3 0 .9.9 0 0 0 .2-.3 1.9 1.9 0 0 0 .1-.5l.9-6.6a1.4 1.4 0 0 0 0-.5.5.5 0 0 0-.1-.3.5.5 0 0 0-.2-.1.8.8 0 0 0-.3 0l-.6-.2.1-.7 4.8.6v.8h-.7a.9.9 0 0 0-.3 0 .4.4 0 0 0-.2 0 .7.7 0 0 0-.2.3 1.8 1.8 0 0 0-.1.4l-.4 2.7 3.6.5.4-2.7a1.6 1.6 0 0 0 0-.5.6.6 0 0 0-.1-.3.7.7 0 0 0-.2-.1 1.1 1.1 0 0 0-.3 0l-.6-.2.1-.7 4.8.7-.1.7-.6-.1h-.3a.5.5 0 0 0-.2 0 .6.6 0 0 0-.2.3 2 2 0 0 0-.1.5l-1 6.7a1.7 1.7 0 0 0 0 .5.6.6 0 0 0 .2.2.6.6 0 0 0 .2.2 1.1 1.1 0 0 0 .3 0l.6.1-.1.7zm9.4.2l2.8.2a.7.7 0 0 0 .4 0 .7.7 0 0 0 .3-.3 1.4 1.4 0 0 0 .2-.3 4.2 4.2 0 0 0 .1-.4l.2-.7h1l-.3 2.7-8.2-.6v-.8h.6a1.3 1.3 0 0 0 .3 0 .5.5 0 0 0 .2 0 .5.5 0 0 0 .2-.3 2 2 0 0 0 .1-.5l.5-6.7a1.8 1.8 0 0 0 0-.5.7.7 0 0 0-.1-.3.5.5 0 0 0-.2-.1h-.9v-.8l7.8.6-.1 2.5h-1v-.7a1.6 1.6 0 0 0-.2-.8.8.8 0 0 0-.7-.3l-2.3-.2-.3 3.5 3.4.2-.1.9-3.3-.3zm19.4-7.9h-.6a.8.8 0 0 0-.3 0 .5.5 0 0 0-.2 0 .6.6 0 0 0-.1.3 1.3 1.3 0 0 0-.1.5v5.5a3.5 3.5 0 0 1-.2 1.3 2.3 2.3 0 0 1-.6 1 3 3 0 0 1-1.1.5 5.6 5.6 0 0 1-1.6.3 6.8 6.8 0 0 1-1.6-.2 3 3 0 0 1-1.2-.6 2.5 2.5 0 0 1-.8-1 3.6 3.6 0 0 1-.3-1.4V198a1.4 1.4 0 0 0 0-.4.6.6 0 0 0-.2-.3.5.5 0 0 0-.2 0 1.2 1.2 0 0 0-.3 0h-.6v-.8h4.8v.7h-.6a1.2 1.2 0 0 0-.2 0 .5.5 0 0 0-.3.1.8.8 0 0 0-.1.3 1.6 1.6 0 0 0 0 .5v5.4a2.9 2.9 0 0 0 0 1 1.6 1.6 0 0 0 .5.6 1.7 1.7 0 0 0 .7.4 2.9 2.9 0 0 0 .8 0 2.8 2.8 0 0 0 .9 0 1.6 1.6 0 0 0 .6-.4 1.7 1.7 0 0 0 .4-.7 2.6 2.6 0 0 0 .1-.9V198a1.8 1.8 0 0 0 0-.4.6.6 0 0 0-.1-.3.6.6 0 0 0-.2-.1h-.9v-.7h3.7zm6.2 1.4c0-.2.2-.4.3-.5a4 4 0 0 0 .2-.4 1.8 1.8 0 0 0 .1-.3 1 1 0 0 0 0-.3.3.3 0 0 0-.2-.3 1.5 1.5 0 0 0-.6 0v-.8l3.8-.2v.7a1.9 1.9 0 0 0-.5.1 2.3 2.3 0 0 0-.5.3 2.9 2.9 0 0 0-.4.5l-.5.5-1.7 2.1 2.9 4a4 4 0 0 0 .4.5 1.6 1.6 0 0 0 .4.4 1.3 1.3 0 0 0 .4.1 1.6 1.6 0 0 0 .5 0v.8h-1.7a6.8 6.8 0 0 1-.6 0 2.3 2.3 0 0 1-.6-.2 1.5 1.5 0 0 1-.4-.2 1.9 1.9 0 0 1-.3-.3 4.2 4.2 0 0 1-.3-.4l-2-3-.7.4.2 2.4a2 2 0 0 0 0 .5.8.8 0 0 0 .3.2.5.5 0 0 0 .2.2 1.4 1.4 0 0 0 .3 0h.6v.7l-4.8.3-.1-.7h.9a.5.5 0 0 0 .2-.2.6.6 0 0 0 .1-.2 1.5 1.5 0 0 0 0-.5l-.4-6.8a1.6 1.6 0 0 0-.1-.4.6.6 0 0 0-.2-.2.5.5 0 0 0-.2-.2 1.3 1.3 0 0 0-.3 0h-.6v-.7l4.8-.3v.7h-.6a1 1 0 0 0-.2 0 .4.4 0 0 0-.3.2.7.7 0 0 0-.1.3 1.4 1.4 0 0 0 0 .5l.2 3.2zm7.1-1.7a2.8 2.8 0 0 1 0 .9 2.4 2.4 0 0 1-.4.8 3 3 0 0 1-.7.7 4.5 4.5 0 0 1-1.1.6v-.7a4 4 0 0 0 .4-.3 1.6 1.6 0 0 0 .4-.3 1 1 0 0 0 .2-.3.9.9 0 0 0 0-.4.3.3 0 0 0-.1-.2 1 1 0 0 0-.2 0l-.3-.2a1 1 0 0 1-.2-.2 1.1 1.1 0 0 1-.3-.3 1.2 1.2 0 0 1-.1-.4.9.9 0 0 1 .2-.8 1 1 0 0 1 .7-.3 1.2 1.2 0 0 1 1 .3 1.7 1.7 0 0 1 .4 1.1zm5.5 8a6.2 6.2 0 0 1-1.6 0 3.2 3.2 0 0 1-1-.3 1.7 1.7 0 0 1-.7-.6 1.6 1.6 0 0 1-.2-.7 1.3 1.3 0 0 1 0-.6 1.4 1.4 0 0 1 .3-.4 1.5 1.5 0 0 1 .4-.3 2.2 2.2 0 0 1 .6-.2 3.6 3.6 0 0 0 .3 1 2 2 0 0 0 .5.7 1.6 1.6 0 0 0 .7.4 1.9 1.9 0 0 0 .8 0 2 2 0 0 0 .7-.2 1.7 1.7 0 0 0 .5-.4 1.3 1.3 0 0 0 .2-.6 1.6 1.6 0 0 0 0-.6 1.3 1.3 0 0 0-.2-.6 1.8 1.8 0 0 0-.5-.4 3.9 3.9 0 0 0-.8-.4l-1-.3a8.5 8.5 0 0 1-1.4-.4 3.5 3.5 0 0 1-.9-.6 2.4 2.4 0 0 1-.5-.7 2.8 2.8 0 0 1-.3-.9 2.4 2.4 0 0 1 0-1.2 2.5 2.5 0 0 1 .7-1 3.2 3.2 0 0 1 1-.7 4.6 4.6 0 0 1 1.3-.4 5.7 5.7 0 0 1 1.3 0 3.1 3.1 0 0 1 1 .1 1.5 1.5 0 0 1 .6.5 1.2 1.2 0 0 1 .3.6 1 1 0 0 1 0 .5 1.1 1.1 0 0 1-.2.4 1.9 1.9 0 0 1-.5.3 2.8 2.8 0 0 1-.8.2 2.6 2.6 0 0 0-.2-.6 2.1 2.1 0 0 0-.3-.6 1.4 1.4 0 0 0-.5-.4 1.2 1.2 0 0 0-.7-.1 1.5 1.5 0 0 0-.5.1 1.2 1.2 0 0 0-.4.3 1.1 1.1 0 0 0-.3.5 1.3 1.3 0 0 0 0 .5 1.4 1.4 0 0 0 .2.6 1.5 1.5 0 0 0 .4.4 3.2 3.2 0 0 0 .8.4 10.9 10.9 0 0 0 1.2.4 7.4 7.4 0 0 1 1.3.4 3.8 3.8 0 0 1 1 .5 2.1 2.1 0 0 1 .5.7 2.7 2.7 0 0 1 .3 1 2.8 2.8 0 0 1-.1 1.2 2.7 2.7 0 0 1-.6 1 3.7 3.7 0 0 1-1.1.9 5.4 5.4 0 0 1-1.6.5z' });

var _ref20 = Object(preact_min["h"])('path', {
	d: 'M70.2 254a169.8 169.8 0 0 1 93.7 10.6 170 170 0 0 0 102.9 8.7v-38.5a170 170 0 0 1-103-8.7 170 170 0 0 0-93.6-10.7',
	fill: '#feca98'
});

var _ref21 = Object(preact_min["h"])('path', { d: 'M88.8 227l2.2 5.2.3.6.2.6.2.6.1.4.1-.5.1-.7.1-.7.1-.7.6-3v-.5a1.5 1.5 0 0 0 0-.2v-.1a.6.6 0 0 0-.3-.5 1.1 1.1 0 0 0-.7-.1h-.3v-.7l3.7-.3v.8h-.3a1.7 1.7 0 0 0-.4 0 .5.5 0 0 0-.2.2 1.1 1.1 0 0 0-.2.3 5.4 5.4 0 0 0-.2.6l-1.6 8.3-1.6.1-2.7-6.4-1.6 6.7-1.7.1-3.1-8.3a1.6 1.6 0 0 0-.2-.4.8.8 0 0 0-.2-.2 1 1 0 0 0-.3-.1 1.4 1.4 0 0 0-.4 0h-.1v-.7l4.6-.3v.7h-.3a1 1 0 0 0-.6.2.6.6 0 0 0-.2.5 2.9 2.9 0 0 0 0 .4l.2.4 1.1 3.1.2.6.2.6.2.6.1.6.2-1c0-.3 0-.5.2-.7l1.4-6.1zm16.7 4.6a6.6 6.6 0 0 1-.3 2.1 4.3 4.3 0 0 1-1 1.6 4 4 0 0 1-1.5 1 5.1 5.1 0 0 1-2 .4 5.5 5.5 0 0 1-2-.4 3.9 3.9 0 0 1-1.5-1 4.4 4.4 0 0 1-.9-1.7 7.4 7.4 0 0 1-.2-2.1 7 7 0 0 1 .3-2.1 4.3 4.3 0 0 1 .9-1.7 3.9 3.9 0 0 1 1.5-1 5.5 5.5 0 0 1 2-.3 5.2 5.2 0 0 1 2 .4 4 4 0 0 1 1.5 1 4.5 4.5 0 0 1 1 1.7 6.7 6.7 0 0 1 .2 2.1zm-7.1 0a10.9 10.9 0 0 0 .1 1.7 4.3 4.3 0 0 0 .4 1.3 2 2 0 0 0 .7.9 2 2 0 0 0 1.1.3 2 2 0 0 0 1.1-.3 2 2 0 0 0 .8-.8 4.5 4.5 0 0 0 .4-1.3 11.8 11.8 0 0 0 .2-1.8 12.3 12.3 0 0 0-.1-1.8 4.6 4.6 0 0 0-.4-1.3 2.3 2.3 0 0 0-.7-.9 2 2 0 0 0-1.1-.3 2 2 0 0 0-1.2.3 2 2 0 0 0-.7.8 4.2 4.2 0 0 0-.5 1.3 11.6 11.6 0 0 0-.1 1.8zm7.9 4.4h.6a.9.9 0 0 0 .3 0 .5.5 0 0 0 .2-.2.6.6 0 0 0 .2-.2 1.2 1.2 0 0 0 .1-.4l.5-6.8a1.5 1.5 0 0 0 0-.5.7.7 0 0 0-.1-.3.5.5 0 0 0-.2 0l-.3-.2h-.6v-.7l4.6.3a5 5 0 0 1 2.8 1 2.2 2.2 0 0 1 .8 2 2.8 2.8 0 0 1-.3 1 2.5 2.5 0 0 1-.4.6 2.6 2.6 0 0 1-.7.5 4.5 4.5 0 0 1-.7.4l1.4 3a4.3 4.3 0 0 0 .3.5 2.5 2.5 0 0 0 .4.4 1.3 1.3 0 0 0 .3.2 1.2 1.2 0 0 0 .4.1v.7h-1.6a3.3 3.3 0 0 1-.8-.3 1.8 1.8 0 0 1-.6-.5 2.9 2.9 0 0 1-.4-.6l-1.4-3.2-1-.1-.2 2.8a1.4 1.4 0 0 0 0 .4.6.6 0 0 0 .2.3.5.5 0 0 0 .2.1 1.1 1.1 0 0 0 .3 0h.6l-.1.7-4.8-.3zm3.9-4.2h.8a2 2 0 0 0 .8 0 1.2 1.2 0 0 0 .5-.4 1.8 1.8 0 0 0 .4-.6 5.1 5.1 0 0 0 .1-.9 4.3 4.3 0 0 0 0-.9 1.5 1.5 0 0 0-.3-.6 1.2 1.2 0 0 0-.5-.4 2.4 2.4 0 0 0-.7-.1l-.8-.1z' });

var _ref22 = Object(preact_min["h"])('path', { d: 'M122.5 230.8l.4-.4a2 2 0 0 0 .3-.3 1.7 1.7 0 0 0 .2-.3 1 1 0 0 0 0-.3.3.3 0 0 0 0-.4 1.5 1.5 0 0 0-.6-.1v-.7l3.8.5v.7a1.7 1.7 0 0 0-.6 0 2.4 2.4 0 0 0-.6.2 3 3 0 0 0-.5.3l-.5.4-2.1 1.8 2 4.4a4 4 0 0 0 .3.6 2.2 2.2 0 0 0 .3.4 1.2 1.2 0 0 0 .4.2 1.6 1.6 0 0 0 .4.2l-.1.7-.8-.1-.9-.2a6.5 6.5 0 0 1-.7-.2 2.2 2.2 0 0 1-.5-.2 1.7 1.7 0 0 1-.3-.3 2.3 2.3 0 0 1-.3-.4l-.2-.4-1.4-3.4-.7.4-.3 2.3a1.6 1.6 0 0 0 0 .5.6.6 0 0 0 .1.3.5.5 0 0 0 .2.1 1.3 1.3 0 0 0 .3.1h.6l-.1.8-4.8-.6.1-.8.6.1h.3a.5.5 0 0 0 .2 0 .6.6 0 0 0 .2-.3 1.6 1.6 0 0 0 .1-.4l1-6.8a1.4 1.4 0 0 0 0-.4.6.6 0 0 0-.2-.3.5.5 0 0 0-.2-.2 1.1 1.1 0 0 0-.3 0l-.6-.1.1-.7 4.8.6v.7h-.7a1.4 1.4 0 0 0-.2 0 .5.5 0 0 0-.3 0 .7.7 0 0 0-.2.3 1.8 1.8 0 0 0-.1.5l-.4 3.2zm12.5 2.6a3.4 3.4 0 0 1-.4 1.1 2.6 2.6 0 0 1-.9 1 3.5 3.5 0 0 1-1.4.4 6 6 0 0 1-1.9-.1l-.5-.1-.4 2.2a1.4 1.4 0 0 0 0 .4.6.6 0 0 0 .3.5h.3l.9.2-.2.7-5-1 .2-.7.5.1h.3a.5.5 0 0 0 .3 0 .7.7 0 0 0 .2-.3 1.5 1.5 0 0 0 .1-.5l1.3-6.6a1.2 1.2 0 0 0 0-.5.5.5 0 0 0-.1-.2.5.5 0 0 0-.2-.2 1 1 0 0 0-.3 0l-.6-.2.2-.7 4.2.8a5.9 5.9 0 0 1 1.6.5 3.2 3.2 0 0 1 1 .8 2.4 2.4 0 0 1 .6 1 3.1 3.1 0 0 1 0 1.4zm-5 1.5h.4a2.5 2.5 0 0 0 .9 0 1.3 1.3 0 0 0 .6-.3 1.7 1.7 0 0 0 .5-.6 4.9 4.9 0 0 0 .3-1 4.4 4.4 0 0 0 .1-1 1.8 1.8 0 0 0-.2-.7 1.2 1.2 0 0 0-.4-.5 2.3 2.3 0 0 0-.7-.3l-.6-.1zm4.3 5.5l.2-.7.5.1a1.6 1.6 0 0 0 .3 0 .4.4 0 0 0 .3 0 .7.7 0 0 0 .2-.3 1.7 1.7 0 0 0 .1-.4l1.7-6.5a1.5 1.5 0 0 0 0-.5.6.6 0 0 0 0-.3.5.5 0 0 0-.3-.2.8.8 0 0 0-.2 0l-.6-.2.2-.7 4.7 1.2-.2.7-.6-.2h-.2a.4.4 0 0 0-.3 0 .6.6 0 0 0-.2.3 1.4 1.4 0 0 0-.2.4l-1.8 7.3 2.5.7a1 1 0 0 0 .9-.1 1.9 1.9 0 0 0 .6-.8l.4-1 .8.2-.9 3zm12.1-.2l-.7 1-.3.3a1.7 1.7 0 0 0-.1.4.4.4 0 0 0 0 .3.4.4 0 0 0 0 .2.9.9 0 0 0 .2.1.7.7 0 0 0 .2.1l.6.2-.2.7-3.5-1 .2-.8h.2a1.5 1.5 0 0 0 .3 0 .7.7 0 0 0 .3 0 1.2 1.2 0 0 0 .4-.2 3.4 3.4 0 0 0 .3-.4l5.4-7 1.8.5.4 8.8a3.7 3.7 0 0 0 0 .5 1.6 1.6 0 0 0 .2.4.8.8 0 0 0 .2.2 1 1 0 0 0 .3.1l.2.1-.2.7-4.4-1.3.2-.8.5.2a.8.8 0 0 0 .5 0 .8.8 0 0 0 .1-.1.7.7 0 0 0 .2-.2 1 1 0 0 0 0-.4 1.3 1.3 0 0 0 0-.2V241zm3.2-2.3v-2.2l-.3.4-.3.5-.3.4-.3.5-1.5 2 2.7.8zm8.4 8.7a3.3 3.3 0 0 0 .9.2 3 3 0 0 0 1.4-.3l.6-.3a.7.7 0 0 1 0 .3.8.8 0 0 1 0 .4 1.3 1.3 0 0 1-.4.5 1.7 1.7 0 0 1-.7.4 3.3 3.3 0 0 1-1 0 5.4 5.4 0 0 1-1.5-.3 5.8 5.8 0 0 1-1.9-1 4 4 0 0 1-1-1.6 4.3 4.3 0 0 1-.2-1.8 6.8 6.8 0 0 1 .4-2.1 6.6 6.6 0 0 1 1-1.9 4.5 4.5 0 0 1 1.4-1.1 4 4 0 0 1 1.8-.5 5.3 5.3 0 0 1 2 .4 7.2 7.2 0 0 1 1.3.6 3.8 3.8 0 0 1 .9.7 1.7 1.7 0 0 1 .3.7 1.2 1.2 0 0 1 0 .7 1 1 0 0 1-.2.4 1 1 0 0 1-.5.2 1.6 1.6 0 0 1-.6 0 2.5 2.5 0 0 1-.7-.2 3.2 3.2 0 0 0 .1-.6 1.7 1.7 0 0 0 0-.7 1.4 1.4 0 0 0-.2-.6 1.6 1.6 0 0 0-.7-.4 2.2 2.2 0 0 0-1.1-.1 2 2 0 0 0-1 .5 4.3 4.3 0 0 0-.8 1 12.3 12.3 0 0 0-.8 1.7 9.3 9.3 0 0 0-.5 1.7 3.4 3.4 0 0 0 0 1.4 2 2 0 0 0 .6 1 3.1 3.1 0 0 0 1.1.7zm6.7 2.8l2.6 1a.8.8 0 0 0 .3 0 .9.9 0 0 0 .4 0 1 1 0 0 0 .2-.3 2 2 0 0 0 .3-.4l.3-.6 1 .4-1 2.4-7.7-3 .3-.7.5.2h.3a.6.6 0 0 0 .2 0 .5.5 0 0 0 .3-.1 1.2 1.2 0 0 0 .2-.4l2.5-6.3a1.9 1.9 0 0 0 0-.5.6.6 0 0 0 0-.3.5.5 0 0 0 0-.2 1.3 1.3 0 0 0-.3-.1l-.6-.2.3-.7 7.2 2.8-.9 2.5-.9-.4.2-.6a1.6 1.6 0 0 0 0-.9.8.8 0 0 0-.5-.5l-2.2-.8-1.3 3.2 3.1 1.2-.3.8-3-1.2zm8.9 3.4l.6.2a1.5 1.5 0 0 0 .2 0 .6.6 0 0 0 .3 0 .7.7 0 0 0 .2-.1 1.3 1.3 0 0 0 .2-.4l2-6.6a1.2 1.2 0 0 0 0-.4.5.5 0 0 0 0-.3.4.4 0 0 0-.2-.2 1.1 1.1 0 0 0-.3 0l-.5-.3.2-.7 4.3 1.4a5 5 0 0 1 2.6 1.4 2.2 2.2 0 0 1 .3 2.2 2.6 2.6 0 0 1-.4.9 2.5 2.5 0 0 1-.7.6 3 3 0 0 1-.7.3 4.3 4.3 0 0 1-.8.1l.8 3.3a3.8 3.8 0 0 0 .2.6 2 2 0 0 0 .2.4 1.3 1.3 0 0 0 .2.3 1.4 1.4 0 0 0 .4.2l-.2.7-.4-.2c-.4 0-.8-.2-1-.3a3.8 3.8 0 0 1-.7-.4 1.9 1.9 0 0 1-.5-.6 2.5 2.5 0 0 1-.3-.7l-.7-3.5-.8-.2-.9 2.6a1.3 1.3 0 0 0 0 .4.6.6 0 0 0 0 .3.5.5 0 0 0 .2.2l.3.1.6.2-.3.7-4.6-1.4zm4.6-3.1l.8.2a2.2 2.2 0 0 0 .8.1 1.2 1.2 0 0 0 .6-.2 1.6 1.6 0 0 0 .5-.6 4.3 4.3 0 0 0 .3-.8 3.8 3.8 0 0 0 .2-.9 1.4 1.4 0 0 0-.1-.6 1.1 1.1 0 0 0-.4-.5 2.7 2.7 0 0 0-.8-.4l-.7-.2zm15.4 4.3a6.9 6.9 0 0 1-.8 2 4.6 4.6 0 0 1-1.3 1.3 4.1 4.1 0 0 1-1.6.6 5 5 0 0 1-2 0 5.5 5.5 0 0 1-2-1 4 4 0 0 1-1.2-1.3 4.5 4.5 0 0 1-.5-1.8 7.3 7.3 0 0 1 .2-2.1 7.4 7.4 0 0 1 .8-2 4.4 4.4 0 0 1 1.2-1.4 4 4 0 0 1 1.7-.6 5.6 5.6 0 0 1 2.1.1 5.3 5.3 0 0 1 2 .8 4 4 0 0 1 1.1 1.4 4.5 4.5 0 0 1 .5 1.8 6.7 6.7 0 0 1-.2 2.1zm-7-1.8a12 12 0 0 0-.2 1.8 4.3 4.3 0 0 0 0 1.4 2 2 0 0 0 .6 1 2.3 2.3 0 0 0 2.2.5 2.1 2.1 0 0 0 .9-.6 4.7 4.7 0 0 0 .7-1.2 12.4 12.4 0 0 0 .5-1.7 11.2 11.2 0 0 0 .3-1.8 4.6 4.6 0 0 0 0-1.4 2.1 2.1 0 0 0-.6-1 2 2 0 0 0-1-.5 2 2 0 0 0-1.1 0 2 2 0 0 0-1 .6 4.3 4.3 0 0 0-.7 1.2 11.1 11.1 0 0 0-.5 1.7zm15.2 8.3l.2-.8h.1a1.8 1.8 0 0 0 .4 0 .7.7 0 0 0 .3 0 .5.5 0 0 0 .2-.2 1 1 0 0 0 .1-.4l1.2-7-4.2 8-1-.2-1.5-9-1.1 6.9a1.2 1.2 0 0 0 0 .5.7.7 0 0 0 .1.3.8.8 0 0 0 .3.2 2.5 2.5 0 0 0 .5 0v.8l-3.5-.6.1-.7h1a.5.5 0 0 0 .2 0 .5.5 0 0 0 .2-.2 1.6 1.6 0 0 0 .1-.4l1.2-6.8a1.8 1.8 0 0 0 0-.4.5.5 0 0 0-.3-.5 1 1 0 0 0-.3 0l-.6-.1.1-.8 4 .7 1.2 7.2 3.3-6.3 4 .7-.2.7-.6-.1a1.3 1.3 0 0 0-.3 0 .4.4 0 0 0-.2 0 .7.7 0 0 0-.2.3 1.7 1.7 0 0 0-.1.5l-1.1 6.6a1.4 1.4 0 0 0 0 .5.8.8 0 0 0 0 .3.6.6 0 0 0 .3.1l.2.1h.6l-.1.8zm8.6-2.2l-.5 1.2a4 4 0 0 0-.2.4 1.4 1.4 0 0 0-.1.3.5.5 0 0 0 0 .3.5.5 0 0 0 .1.2.8.8 0 0 0 .5.1l.5.1v.7l-3.7-.3.1-.7h.2a1.3 1.3 0 0 0 .3 0 .6.6 0 0 0 .3-.2 1.3 1.3 0 0 0 .3-.3 3.2 3.2 0 0 0 .3-.4l3.8-8 2 .2 2 8.5a3.5 3.5 0 0 0 .2.5 1.3 1.3 0 0 0 .2.4.8.8 0 0 0 .3.2 1 1 0 0 0 .3 0h.3l-.1.8-4.6-.5v-.7h.8a.7.7 0 0 0 .2 0 .5.5 0 0 0 .2-.2.4.4 0 0 0 0-.2 1.2 1.2 0 0 0 0-.4v-.2l-.3-1.5zm2.6-2.9v-.5l-.2-.6v-.5l-.1-.6-.2.5c0 .2-.2.3-.3.5l-.2.5-.2.5-1 2.3 2.8.2zm13 7.2l-5.2-7.9-.2 6a1.6 1.6 0 0 0 0 .6.8.8 0 0 0 .2.2.5.5 0 0 0 .2.2 1.3 1.3 0 0 0 .3 0h.5v.7l-3.6-.1v-.8h.8a.5.5 0 0 0 .3 0 .6.6 0 0 0 .1-.3 1.5 1.5 0 0 0 .1-.5l.2-6.8a1.4 1.4 0 0 0 0-.4.6.6 0 0 0-.2-.3.5.5 0 0 0-.2-.1 1.1 1.1 0 0 0-.3 0h-.5v-.7h3l4.8 7.2.1-5.4a1.5 1.5 0 0 0 0-.4.7.7 0 0 0-.1-.3.6.6 0 0 0-.2-.1h-.9v-.8l3.7.2v.7h-.6a.8.8 0 0 0-.3 0 .5.5 0 0 0-.2.1.6.6 0 0 0-.2.3 1.7 1.7 0 0 0 0 .5l-.3 8.3zm9-1.1a3 3 0 0 0 1-.1 3.3 3.3 0 0 0 .7-.3 3 3 0 0 0 .5-.5 5.7 5.7 0 0 0 .4-.5.6.6 0 0 1 .2.3.8.8 0 0 1 0 .3 1.4 1.4 0 0 1 0 .7 1.7 1.7 0 0 1-.6.6 3 3 0 0 1-1 .4 5.5 5.5 0 0 1-1.5.3 5.7 5.7 0 0 1-2.1-.4 4 4 0 0 1-1.5-1 4.3 4.3 0 0 1-1-1.6 7.3 7.3 0 0 1-.1-4.1 4.5 4.5 0 0 1 .9-1.7 4 4 0 0 1 1.5-1 5.4 5.4 0 0 1 2-.5 6.8 6.8 0 0 1 1.5 0 3.8 3.8 0 0 1 1 .4 1.7 1.7 0 0 1 .6.5 1.2 1.2 0 0 1 .2.6 1 1 0 0 1-.1.5 1.2 1.2 0 0 1-.3.4 2 2 0 0 1-.6.3 3.3 3.3 0 0 1-.7 0 3.3 3.3 0 0 0-.1-.6 1.8 1.8 0 0 0-.3-.6 1.4 1.4 0 0 0-1.2-.6 2.1 2.1 0 0 0-1.1.3 2.1 2.1 0 0 0-.8.8 4.7 4.7 0 0 0-.3 1.4 11.3 11.3 0 0 0-.1 1.8 9.6 9.6 0 0 0 .2 1.7 3.6 3.6 0 0 0 .5 1.3 2.1 2.1 0 0 0 1 .7 3 3 0 0 0 1.3.2zm7.6-.3l2.8-.2a.7.7 0 0 0 .4-.1.7.7 0 0 0 .2-.2 1 1 0 0 0 .2-.4 3 3 0 0 0 0-.4v-.7h1l.2 2.5-8.2.7v-.8h.8a.5.5 0 0 0 .2-.2.5.5 0 0 0 .2-.2 1.2 1.2 0 0 0 0-.5l-.6-6.7a2 2 0 0 0 0-.5.7.7 0 0 0-.3-.3.4.4 0 0 0-.2 0 1.4 1.4 0 0 0-.3 0h-.6v-.8l7.7-.6.3 2.5-1 .1-.1-.6a1.6 1.6 0 0 0-.3-.8.7.7 0 0 0-.7-.2l-2.3.2.3 3.5 3.3-.3v.9l-3.2.2zm9.2.1a6.2 6.2 0 0 1-1.5 0 3 3 0 0 1-1-.4 1.6 1.6 0 0 1-.7-.5 1.8 1.8 0 0 1-.2-.7 1.3 1.3 0 0 1 0-.6 1 1 0 0 1 .3-.4 1.3 1.3 0 0 1 .5-.3 2.6 2.6 0 0 1 .6-.2 3.6 3.6 0 0 0 .3 1 2.2 2.2 0 0 0 .5.7 1.6 1.6 0 0 0 .6.4 1.9 1.9 0 0 0 .8 0 2 2 0 0 0 .7-.2 1.5 1.5 0 0 0 .5-.4 1.4 1.4 0 0 0 .3-1.1 1.3 1.3 0 0 0-.2-.7 1.7 1.7 0 0 0-.5-.4 3.7 3.7 0 0 0-.8-.3l-1-.4a8.1 8.1 0 0 1-1.4-.4 3.9 3.9 0 0 1-.9-.6 2.6 2.6 0 0 1-.5-.7 3.2 3.2 0 0 1-.3-1 2.6 2.6 0 0 1 .1-1.1 2.6 2.6 0 0 1 .6-1 3.2 3.2 0 0 1 1-.7 4.3 4.3 0 0 1 1.4-.4 5.7 5.7 0 0 1 1.3 0 2.8 2.8 0 0 1 1 .2 1.5 1.5 0 0 1 .6.4 1.3 1.3 0 0 1 .3.6 1 1 0 0 1 0 .5 1 1 0 0 1-.3.4 1.8 1.8 0 0 1-.5.3 3.2 3.2 0 0 1-.7.2 3.1 3.1 0 0 0-.2-.6 2.5 2.5 0 0 0-.3-.6 1.5 1.5 0 0 0-.6-.4 1.3 1.3 0 0 0-.7-.1 1.9 1.9 0 0 0-.5.1 1 1 0 0 0-.4.3 1.1 1.1 0 0 0-.2.5 1.5 1.5 0 0 0 0 .5 1.8 1.8 0 0 0 .1.6 1.4 1.4 0 0 0 .5.4 2.8 2.8 0 0 0 .7.4 10.7 10.7 0 0 0 1.2.4 8.4 8.4 0 0 1 1.3.4 3.7 3.7 0 0 1 1 .6 2.4 2.4 0 0 1 .5.7 2.8 2.8 0 0 1 .3.9 3 3 0 0 1-.1 1.3 2.7 2.7 0 0 1-.7 1 3.6 3.6 0 0 1-1 .8 5.3 5.3 0 0 1-1.8.6z' });

var _ref23 = Object(preact_min["h"])('path', {
	d: 'M80.6 85.1v-2.4h1.9a3.9 3.9 0 0 0 .9 0 1.5 1.5 0 0 0 .7-.5 2 2 0 0 0 .5-.9 5.3 5.3 0 0 0 .2-1.5v-10H73.1v10a5.3 5.3 0 0 0 .1 1.5 2.3 2.3 0 0 0 .5 1 1.5 1.5 0 0 0 .8.3 3.9 3.9 0 0 0 .9.1h1.9v2.4H61.8v-2.4h1.9a3.9 3.9 0 0 0 .8 0 1.5 1.5 0 0 0 .8-.5 2 2 0 0 0 .5-.9 5.4 5.4 0 0 0 .2-1.5V58.1a4.4 4.4 0 0 0-.2-1.4 2 2 0 0 0-.5-.8 1.6 1.6 0 0 0-.7-.4 3.7 3.7 0 0 0-1-.1h-1.8V53h15.5v2.4h-2a3.9 3.9 0 0 0-.8.1 1.5 1.5 0 0 0-.8.4 2.3 2.3 0 0 0-.5.9 5 5 0 0 0-.1 1.5V67h11.7v-8.7a5 5 0 0 0-.2-1.5 2 2 0 0 0-.5-1 1.5 1.5 0 0 0-.7-.3 3.9 3.9 0 0 0-.9-.1h-2V53h15.6v2.4h-1.9a3.6 3.6 0 0 0-.9.1 1.5 1.5 0 0 0-.7.4 2 2 0 0 0-.5.9 5 5 0 0 0-.2 1.5V80a4.3 4.3 0 0 0 .2 1.4 1.8 1.8 0 0 0 .5.8 1.7 1.7 0 0 0 .7.4 4.1 4.1 0 0 0 1 0H96v2.5zM122.4 73q0 6.4-3 9.5t-8.8 3a14.3 14.3 0 0 1-4.8-.7 9.4 9.4 0 0 1-3.7-2.3 10.1 10.1 0 0 1-2.3-4A17.3 17.3 0 0 1 99 73q0-6.3 3-9.4c2-2.1 5-3.1 8.8-3.1a14 14 0 0 1 4.8.7 9.4 9.4 0 0 1 3.7 2.4 10.1 10.1 0 0 1 2.3 3.9 17 17 0 0 1 .8 5.5zM106 73a31.4 31.4 0 0 0 .3 4.2 10.9 10.9 0 0 0 .8 3 4.3 4.3 0 0 0 1.4 2 3.7 3.7 0 0 0 2.2.6 3.6 3.6 0 0 0 2.2-.7 4.3 4.3 0 0 0 1.5-1.8 10.9 10.9 0 0 0 .8-3 33 33 0 0 0 .2-4.3 31.5 31.5 0 0 0-.2-4.2 10.4 10.4 0 0 0-.9-3A4.2 4.2 0 0 0 113 64a4.3 4.3 0 0 0-4.4 0 4.2 4.2 0 0 0-1.5 1.7 10.8 10.8 0 0 0-.8 3 30.8 30.8 0 0 0-.2 4.3zm40.3-11.8l4.4 13.3a24.1 24.1 0 0 1 .8 2.8l.3 2h.2l.2-1.1.3-1 .3-1.3c0-.5.2-.9.4-1.5l2-6.5a10 10 0 0 0 .3-1.3 6.7 6.7 0 0 0 .1-1 2 2 0 0 0-.7-1.6 3.9 3.9 0 0 0-2.3-.6h-.3V61h10.3v2.4h-.6a4 4 0 0 0-1.1.1 2 2 0 0 0-.9.5 4.3 4.3 0 0 0-.7 1 14.3 14.3 0 0 0-.7 1.9L152.8 85H148l-5-15-5 15h-5l-5.8-19.4a5.6 5.6 0 0 0-.5-1.1 2.4 2.4 0 0 0-1.5-1.1 5.5 5.5 0 0 0-1.2-.1h-.1V61h13.2v2.4h-.6a4.2 4.2 0 0 0-2 .4 1.6 1.6 0 0 0-.7 1.5 4.6 4.6 0 0 0 .1.9l.3 1 1.7 5.8.4 1.7c0 .6.2 1.1.3 1.6l.4 1.6.2 1.3h.1a28.4 28.4 0 0 1 1.5-5.2l4.6-12.8zm28.3 21.5a5.4 5.4 0 0 0 1.1 0 2.5 2.5 0 0 0 1.8-1.4 3.2 3.2 0 0 0 .3-1.5V56a2.9 2.9 0 0 0-.3-1.4 2.5 2.5 0 0 0-.8-.8 2.8 2.8 0 0 0-1-.4 5.5 5.5 0 0 0-1-.1h-.5v-2.4h10.5v28.9a3 3 0 0 0 .4 1.5 2.5 2.5 0 0 0 .7 1 2.6 2.6 0 0 0 1 .3 5.4 5.4 0 0 0 1.1.1h.5v2.4h-14.3v-2.4zm39.6-9.7q0 6.4-3 9.5t-8.8 3a14.3 14.3 0 0 1-4.8-.7 9.3 9.3 0 0 1-3.6-2.4 10.4 10.4 0 0 1-2.3-3.9 17.6 17.6 0 0 1-.8-5.5q0-6.4 3-9.5t8.8-3a14 14 0 0 1 4.8.7 9.4 9.4 0 0 1 3.7 2.3 10.4 10.4 0 0 1 2.3 4 17.4 17.4 0 0 1 .7 5.5zm-16.4 0a31.4 31.4 0 0 0 .3 4.2 10.8 10.8 0 0 0 .8 3 4.3 4.3 0 0 0 1.5 2 3.8 3.8 0 0 0 2.1.6 3.6 3.6 0 0 0 2.2-.7 4.4 4.4 0 0 0 1.5-1.8 11.2 11.2 0 0 0 .8-3 33 33 0 0 0 .2-4.3 31.5 31.5 0 0 0-.2-4.2 11.2 11.2 0 0 0-.8-3 4 4 0 0 0-7.3 0 11.2 11.2 0 0 0-.8 3 33.2 33.2 0 0 0-.3 4.2zm45.3-9.6h-.9a3 3 0 0 0-.8 0 1.8 1.8 0 0 0-.7.5 4 4 0 0 0-.7 1 17.6 17.6 0 0 0-.7 1.8L232.8 85h-6l-7.3-19.5a3.9 3.9 0 0 0-.6-1.1 2.5 2.5 0 0 0-.8-.7 3.2 3.2 0 0 0-1-.3 8.2 8.2 0 0 0-1.3-.1V61h14v2.4h-1.9a1.6 1.6 0 0 0-1 .4 1.4 1.4 0 0 0-.5 1 4 4 0 0 0 .1 1.1l.3.9 3 8.5 1 2.9a22 22 0 0 1 .6 2.6l.3-1.2.5-1.4.3-1.2.2-.8 3-9 .5-1.2a5.8 5.8 0 0 0 0-1.2 1 1 0 0 0-.4-1 2.6 2.6 0 0 0-1.3-.3h-1.3V61h10zm13.3 22.1a14 14 0 0 1-5-.8 9.6 9.6 0 0 1-3.6-2.4 10.2 10.2 0 0 1-2.2-3.9 17 17 0 0 1-.8-5.2 18.3 18.3 0 0 1 .8-5.6 10.8 10.8 0 0 1 2.1-4 9 9 0 0 1 3.6-2.4 14.3 14.3 0 0 1 9 0 8.7 8.7 0 0 1 3.4 2 9.1 9.1 0 0 1 2 3.3 13.9 13.9 0 0 1 .8 4.7v2.3h-14.8a17.6 17.6 0 0 0 .5 3.9 8.2 8.2 0 0 0 1.2 2.7 4.7 4.7 0 0 0 1.9 1.5 5.9 5.9 0 0 0 2.4.5 7.8 7.8 0 0 0 2.2-.2 7 7 0 0 0 1.8-.8A6.3 6.3 0 0 0 263 80a6.5 6.5 0 0 0 1-1.4 2.3 2.3 0 0 1 1.2 2.2 3.5 3.5 0 0 1-.5 1.8 4.5 4.5 0 0 1-1.6 1.5 9.7 9.7 0 0 1-2.8 1 17.5 17.5 0 0 1-4 .5zm-.4-22.2a3.4 3.4 0 0 0-3 2 11.5 11.5 0 0 0-1.2 5.4h7.8a21.1 21.1 0 0 0-.2-3.1 8.4 8.4 0 0 0-.7-2.3 3.5 3.5 0 0 0-1-1.4 2.6 2.6 0 0 0-1.7-.6zm-138.5 51.9l4.4 13.3a24.1 24.1 0 0 1 .7 2.8l.5 2 .3-1.1.2-1 .4-1.3.4-1.5 2-6.5.3-1.3a5.6 5.6 0 0 0 .1-1 2 2 0 0 0-.7-1.6 3.9 3.9 0 0 0-2.3-.6h-.3V115h10.3v2.4h-.6a4 4 0 0 0-1.1.1 2 2 0 0 0-.9.5 4.3 4.3 0 0 0-.7 1.1 14.3 14.3 0 0 0-.6 1.8l-5.9 18.2h-4.9l-4.9-15-5.1 15h-5l-5.7-19.3a5.6 5.6 0 0 0-.6-1.2 2.4 2.4 0 0 0-.6-.7 2.5 2.5 0 0 0-.9-.4 5.4 5.4 0 0 0-1.1-.1H95V115h13.2v2.4h-.6a4 4 0 0 0-2 .4 1.6 1.6 0 0 0-.7 1.5 4.6 4.6 0 0 0 .1.9l.3 1 1.7 5.8.4 1.7c0 .6.2 1.1.4 1.7l.3 1.5.2 1.3h.1a24.8 24.8 0 0 1 1.5-5.2l4.6-12.8zm41.3 11.8q0 6.4-3 9.5c-2 2-5 3-8.8 3a14.3 14.3 0 0 1-4.8-.7 9.3 9.3 0 0 1-3.7-2.3 10.3 10.3 0 0 1-2.3-4 17.6 17.6 0 0 1-.8-5.5q0-6.3 3-9.4c2-2.1 4.9-3.1 8.8-3.1a14 14 0 0 1 4.8.7 9.4 9.4 0 0 1 3.7 2.4 10.2 10.2 0 0 1 2.3 3.9 17 17 0 0 1 .8 5.5zm-16.4 0a31.4 31.4 0 0 0 .3 4.2 11.3 11.3 0 0 0 .8 3 4.3 4.3 0 0 0 1.4 2 4.1 4.1 0 0 0 4.4 0 4.5 4.5 0 0 0 1.5-2 11.2 11.2 0 0 0 .8-3 33 33 0 0 0 .2-4.2 31.5 31.5 0 0 0-.3-4.2 11.2 11.2 0 0 0-.8-3 4 4 0 0 0-5.8-1.8 4.3 4.3 0 0 0-1.5 1.8 10.8 10.8 0 0 0-.8 3 33.2 33.2 0 0 0-.2 4.2zm34 12.1h-15v-2.4a9.3 9.3 0 0 0 1.5 0 2.4 2.4 0 0 0 1-.5 2.2 2.2 0 0 0 .8-1 4.6 4.6 0 0 0 .3-1.7v-13a4.5 4.5 0 0 0-.3-1.6 2 2 0 0 0-.6-1 2.3 2.3 0 0 0-1-.4 8.5 8.5 0 0 0-1.4 0h-.1V115h9l1 3.5h.2a10.3 10.3 0 0 1 1-1.8 5 5 0 0 1 1.3-1.2 5.3 5.3 0 0 1 1.7-.8 10 10 0 0 1 2.4-.2 6.5 6.5 0 0 1 3.9 1 3.1 3.1 0 0 1 1.3 2.6 3.8 3.8 0 0 1-1.5 3.2 6.9 6.9 0 0 1-4.3 1.2 14.8 14.8 0 0 0 0-1.7 3.4 3.4 0 0 0-.4-1.1 1.6 1.6 0 0 0-.7-.7 2.2 2.2 0 0 0-1-.3 2.4 2.4 0 0 0-1.4.4 3.4 3.4 0 0 0-1 1 5.7 5.7 0 0 0-.7 1.5 12.3 12.3 0 0 0-.4 1.5 13.3 13.3 0 0 0-.2 1.6v9a4.1 4.1 0 0 0 .3 1.6 2 2 0 0 0 .6 1 2.3 2.3 0 0 0 1 .3 7.4 7.4 0 0 0 1.3.1h1.4zm35.7 0h-4.7a12.8 12.8 0 0 1-3-.6 5.5 5.5 0 0 1-2-1.2 10.8 10.8 0 0 1-1.8-2.2l-4-6.3-1.7 1.3v3.7a3.2 3.2 0 0 0 .3 1.5 2.5 2.5 0 0 0 1.8 1.3 5.3 5.3 0 0 0 1 .1h.5v2.4h-14.3v-2.4h.5a5.4 5.4 0 0 0 1 0 2.6 2.6 0 0 0 1-.5 2.5 2.5 0 0 0 .9-.9 3 3 0 0 0 .3-1.5V110a2.7 2.7 0 0 0-.3-1.4 2.4 2.4 0 0 0-.8-.8 2.8 2.8 0 0 0-1-.4 5.5 5.5 0 0 0-1-.1h-.6v-2.4h10.6v18.8a11.2 11.2 0 0 1 0 1.5l-.2 1.8 5.7-6.4a6.1 6.1 0 0 0 1-1.3 2 2 0 0 0 .2-.8 1 1 0 0 0-.6-1 3.8 3.8 0 0 0-1.7-.2V115h11.3v2.3a6 6 0 0 0-3 .9 15.3 15.3 0 0 0-3.3 2.9l-2.8 3.2 6 9a10 10 0 0 0 2.3 2.6 4 4 0 0 0 2.3.8h.2zm9.9.5a19.4 19.4 0 0 1-4-.4 8.6 8.6 0 0 1-2.9-1.1 4.3 4.3 0 0 1-1.6-1.7 4.5 4.5 0 0 1-.5-2.1 3.2 3.2 0 0 1 .5-1.8 3.1 3.1 0 0 1 1-1 4 4 0 0 1 1.4-.5 7.4 7.4 0 0 1 1.3 0 8.3 8.3 0 0 0 .4 2.4 5.3 5.3 0 0 0 1 2 4.3 4.3 0 0 0 1.5 1.1 4.6 4.6 0 0 0 2 .5 7.5 7.5 0 0 0 2-.3 4 4 0 0 0 1.4-.6 2.7 2.7 0 0 0 1-2.2 3 3 0 0 0-.2-1.3 3.3 3.3 0 0 0-1-1.1 8.6 8.6 0 0 0-1.6-1 22 22 0 0 0-2.7-1 26.7 26.7 0 0 1-3.2-1.4 10 10 0 0 1-2.4-1.6 6.1 6.1 0 0 1-1.4-2.2 7.1 7.1 0 0 1-.5-2.7 6.7 6.7 0 0 1 .7-3.1 6.1 6.1 0 0 1 2-2.3 9.2 9.2 0 0 1 3-1.3 16.8 16.8 0 0 1 4-.4 15.7 15.7 0 0 1 3.6.3 8.7 8.7 0 0 1 2.5 1 4.1 4.1 0 0 1 1.3 1.4 3 3 0 0 1 .5 1.5 2.7 2.7 0 0 1-1.1 2.3 6 6 0 0 1-3.5.8 5.4 5.4 0 0 0-1-3.5 3.6 3.6 0 0 0-3-1.3 5.5 5.5 0 0 0-1.4.2 3.5 3.5 0 0 0-1.2.5 2.9 2.9 0 0 0-.8.9 2.4 2.4 0 0 0-.3 1.2 3 3 0 0 0 .3 1.3 3 3 0 0 0 1 1.1 10.3 10.3 0 0 0 1.9 1l3 1.2a19.9 19.9 0 0 1 2.7 1.2 9.8 9.8 0 0 1 2.2 1.5 6.2 6.2 0 0 1 1.4 2 6 6 0 0 1 .5 2.5 8.2 8.2 0 0 1-.6 3.4 6.5 6.5 0 0 1-2 2.5 8.9 8.9 0 0 1-3 1.5 14.3 14.3 0 0 1-4.1.6z',
	fill: '#fff'
});

var _ref24 = Object(preact_min["h"])(
	'p',
	null,
	'How many of us are up for dating a colleague? What happens when passion mixes with paperwork? Do we keep it a secret or circulate a memo? And which jobs offer the best chance of a date? We surveyed more than 5,000 people to reveal the secrets of the UK\u2019s work romances\u2026'
);

var _ref25 = Object(preact_min["h"])(
	'p',
	null,
	Object(preact_min["h"])(components_NextArrow, { to: 'how-we-meet' })
);

var Intro_Intro = function (_Component) {
	Intro__inherits(Intro, _Component);

	function Intro(props) {
		Intro__classCallCheck(this, Intro);

		var _this = Intro__possibleConstructorReturn(this, _Component.call(this, props));

		_this.onDrag = _this.onDrag.bind(_this);

		_this.state = {
			dragging: null,
			text: [{
				x: 428,
				y: 288,
				style: 1,
				rotation: 0,
				text: 'Lose',
				text2: 'CTRL'
			}, {
				x: 861,
				y: 282,
				style: 3,
				rotation: 20,
				text: 'Adobe',
				text2: 'mine'
			}, {
				x: 730,
				y: -456,
				style: 2,
				rotation: 3,
				text: 'Firefoxy',
				text2: 'lady'
			}, {
				x: -529,
				y: 36,
				style: 4,
				rotation: -10,
				text: 'Outlook',
				text2: 'me up'
			}, {
				x: -412,
				y: -380,
				style: 1,
				rotation: 6,
				text: 'Find',
				text2: 'me'
			}, {
				x: -584,
				y: 186,
				style: 2,
				rotation: -30,
				text: 'Word',
				text2: 'up'
			}, {
				x: -585,
				y: -347,
				style: 3,
				rotation: 16,
				text: 'Email',
				text2: 'me'
			}, {
				x: 860,
				y: -402,
				style: 1,
				rotation: -5,
				text: 'Skype',
				text2: 'me'
			}, {
				x: 555,
				y: -174,
				style: 3,
				rotation: 4,
				text: 'Call',
				text2: 'HR'
			}, {
				x: -152,
				y: -337,
				style: 1,
				rotation: 11,
				text: 'Lose',
				text2: 'CTRL'
			}, {
				x: -276,
				y: 197,
				style: 2,
				rotation: -10,
				text: 'Adobe',
				text2: 'mine'
			}, {
				x: -270,
				y: -446,
				style: 3,
				rotation: 6,
				text: 'Firefoxy',
				text2: 'lady'
			}, {
				x: -359,
				y: 87,
				style: 3,
				rotation: 8,
				text: 'Outlook',
				text2: 'me up'
			}, {
				x: -294,
				y: -62,
				style: 1,
				rotation: -22,
				text: 'Find',
				text2: 'me'
			}, {
				x: 822,
				y: 113,
				style: 2,
				rotation: -3,
				text: 'Word',
				text2: 'up'
			}, {
				x: -415,
				y: 272,
				style: 1,
				rotation: 11,
				text: 'Email',
				text2: 'me'
			}, {
				x: 856,
				y: -99,
				style: 4,
				rotation: 4,
				text: 'Skype',
				text2: 'me'
			}, {
				x: 646,
				y: 209,
				style: 1,
				rotation: 17,
				text: 'Call',
				text2: 'HR'
			}, {
				x: -158,
				y: 271,
				style: 4,
				rotation: -3,
				text: 'Lose',
				text2: 'CTRL'
			}, {
				x: 718,
				y: -126,
				style: 2,
				rotation: 8,
				text: 'Adobe',
				text2: 'mine'
			}, {
				x: 732,
				y: 1,
				style: 3,
				rotation: -4,
				text: 'Firefoxy',
				text2: 'lady'
			}, {
				x: -319,
				y: -276,
				style: 2,
				rotation: -6,
				text: 'Outlook',
				text2: 'me up'
			}, {
				x: 674,
				y: -255,
				style: 1,
				rotation: 30,
				text: 'Find',
				text2: 'me'
			}, {
				x: 589,
				y: 42,
				style: 4,
				rotation: 20,
				text: 'Word',
				text2: 'up'
			}, {
				x: -435,
				y: -96,
				style: 3,
				rotation: 10,
				text: 'Email',
				text2: 'me'
			}, {
				x: 480,
				y: -51,
				style: 2,
				rotation: -20,
				text: 'Skype',
				text2: 'me'
			}, {
				x: -12,
				y: -471,
				style: 1,
				rotation: 22,
				text: 'Call',
				text2: 'HR'
			}, {
				x: -150,
				y: 105,
				style: 1,
				rotation: 4,
				text: 'Lose',
				text2: 'CTRL'
			}, {
				x: 470,
				y: 106,
				style: 3,
				rotation: -6,
				text: 'Adobe',
				text2: 'mine'
			}, {
				x: -154,
				y: -78,
				style: 2,
				rotation: 5,
				text: 'Firefoxy',
				text2: 'lady'
			}, {
				x: -125,
				y: -213,
				style: 4,
				rotation: 13,
				text: 'Outlook',
				text2: 'me up'
			}, {
				x: 417,
				y: -253,
				style: 1,
				rotation: -13,
				text: 'Find',
				text2: 'me'
			}, {
				x: 854,
				y: -254,
				style: 2,
				rotation: 3,
				text: 'Word',
				text2: 'up'
			}, {
				x: 592,
				y: -395,
				style: 4,
				rotation: 8,
				text: 'Email',
				text2: 'me'
			}, {
				x: 615,
				y: 319,
				style: 3,
				rotation: 26,
				text: 'Skype',
				text2: 'me'
			}, {
				x: -560,
				y: -187,
				style: 1,
				rotation: -18,
				text: 'Call',
				text2: 'HR'
			}, {
				x: 828,
				y: -164,
				style: 1,
				rotation: -6,
				isSparkle: true
			}, {
				x: -86,
				y: -410,
				style: 1,
				rotation: 6,
				isSparkle: true
			}, {
				x: -321,
				y: -145,
				style: 1,
				rotation: 2,
				isSparkle: true
			}, {
				x: -444,
				y: -264,
				style: 1,
				rotation: 3,
				isSparkle: true
			}, {
				x: 447,
				y: -343,
				style: 1,
				rotation: 10,
				isSparkle: true
			}, {
				x: 770,
				y: -327,
				style: 1,
				rotation: -20,
				isSparkle: true
			}, {
				x: -377,
				y: -2,
				style: 1,
				rotation: 5,
				isSparkle: true
			}, {
				x: -429,
				y: 171,
				style: 1,
				rotation: -6,
				isSparkle: true
			}, {
				x: -232,
				y: 70,
				style: 1,
				rotation: 6,
				isSparkle: true
			}, {
				x: 573,
				y: -258,
				style: 1,
				rotation: 16,
				isSparkle: true
			}, {
				x: -178,
				y: -138,
				style: 1,
				rotation: -16,
				isSparkle: true
			}, {
				x: 577,
				y: 283,
				style: 1,
				rotation: 12,
				isSparkle: true
			}, {
				x: 780,
				y: 248,
				style: 1,
				rotation: -6,
				isSparkle: true
			}, {
				x: 581,
				y: 163,
				style: 1,
				rotation: 6,
				isSparkle: true
			}, {
				x: 729,
				y: 122,
				style: 1,
				rotation: 2,
				isSparkle: true
			}, {
				x: 622,
				y: -41,
				style: 1,
				rotation: 3,
				isSparkle: true
			}, {
				x: 24,
				y: 285,
				style: 1,
				rotation: 10,
				isSparkle: true
			}, {
				x: -276,
				y: 305,
				style: 1,
				rotation: -20,
				isSparkle: true
			}, {
				x: -79,
				y: 16,
				style: 1,
				rotation: 5,
				isSparkle: true
			}, {
				x: 38,
				y: -60,
				style: 1,
				rotation: -6,
				isSparkle: true
			}, {
				x: 421,
				y: 190,
				style: 1,
				rotation: 6,
				isSparkle: true
			}, {
				x: -527,
				y: 311,
				style: 1,
				rotation: 16,
				isSparkle: true
			}, {
				x: 436,
				y: -100,
				style: 1,
				rotation: -16,
				isSparkle: true
			}, {
				x: 321,
				y: 335,
				style: 1,
				rotation: 12,
				isSparkle: true
			}, {
				isMobile: true,
				x: -103,
				y: 272,
				style: 1,
				rotation: 30,
				text: 'Lose',
				text2: 'CTRL'
			}, {
				isMobile: true,
				x: 351,
				y: 145,
				style: 3,
				rotation: -30,
				text: 'Adobe',
				text2: 'mine'
			}, {
				isMobile: true,
				x: 248,
				y: -328,
				style: 2,
				rotation: 10,
				text: 'Firefoxy',
				text2: 'lady'
			}, {
				isMobile: true,
				x: 186,
				y: 285,
				style: 4,
				rotation: 20,
				text: 'Outlook',
				text2: 'me up'
			}, {
				isMobile: true,
				x: 334,
				y: 22,
				style: 1,
				rotation: 7,
				text: 'Find',
				text2: 'me'
			}, {
				isMobile: true,
				x: 244,
				y: 229,
				style: 2,
				rotation: -7,
				text: 'Word',
				text2: 'up'
			}, {
				isMobile: true,
				x: -99,
				y: 91,
				style: 3,
				rotation: 12,
				text: 'Email',
				text2: 'me'
			}, {
				isMobile: true,
				x: 252,
				y: -56,
				style: 1,
				rotation: 15,
				text: 'Skype',
				text2: 'me'
			}, {
				isMobile: true,
				x: -31,
				y: -68,
				style: 3,
				rotation: -11,
				text: 'Call',
				text2: 'HR'
			}, {
				isMobile: true,
				x: -87,
				y: -203,
				style: 1,
				rotation: -22,
				text: 'Lose',
				text2: 'CTRL'
			}, {
				isMobile: true,
				x: -122,
				y: -40,
				style: 2,
				rotation: 6,
				text: 'Adobe',
				text2: 'mine'
			}, {
				isMobile: true,
				x: -21,
				y: 234,
				style: 3,
				rotation: 8,
				text: 'Firefoxy',
				text2: 'lady'
			}, {
				isMobile: true,
				x: 350,
				y: -93,
				style: 3,
				rotation: 2,
				text: 'Outlook',
				text2: 'me up'
			}, {
				isMobile: true,
				x: 43,
				y: 302,
				style: 1,
				rotation: -6,
				text: 'Find',
				text2: 'me'
			}, {
				isMobile: true,
				x: -119,
				y: -115,
				style: 1,
				rotation: -6,
				isSparkle: true
			}, {
				isMobile: true,
				x: -119,
				y: 303,
				style: 1,
				rotation: 6,
				isSparkle: true
			}, {
				isMobile: true,
				x: 368,
				y: 316,
				style: 1,
				rotation: 2,
				isSparkle: true
			}, {
				isMobile: true,
				x: 151,
				y: 315,
				style: 1,
				rotation: 3,
				isSparkle: true
			}, {
				isMobile: true,
				x: -51,
				y: 178,
				style: 1,
				rotation: 10,
				isSparkle: true
			}, {
				isMobile: true,
				x: -57,
				y: 39,
				style: 1,
				rotation: -20,
				isSparkle: true
			}, {
				isMobile: true,
				x: 326,
				y: 107,
				style: 1,
				rotation: 5,
				isSparkle: true
			}, {
				isMobile: true,
				x: 312,
				y: -33,
				style: 1,
				rotation: -6,
				isSparkle: true
			}, {
				isMobile: true,
				x: 220,
				y: -9,
				style: 1,
				rotation: 6,
				isSparkle: true
			}, {
				isMobile: true,
				x: 68,
				y: 247,
				style: 1,
				rotation: 16,
				isSparkle: true
			}, {
				isMobile: true,
				x: 338,
				y: -159,
				style: 1,
				rotation: -16,
				isSparkle: true
			}, {
				isMobile: true,
				x: 62,
				y: -17,
				style: 1,
				rotation: 12,
				isSparkle: true
			}, {
				isMobile: true,
				x: 67,
				y: -338,
				style: 1,
				rotation: -5,
				isSparkle: true
			}, {
				isMobile: true,
				x: 208,
				y: -332,
				style: 1,
				rotation: 5,
				isSparkle: true
			}, {
				isMobile: true,
				x: -26,
				y: -356,
				style: 4,
				rotation: 12,
				text: 'Outlook',
				text2: 'me up'
			}]
		};
		return _this;
	}

	Intro.prototype.startDragging = function startDragging(e, i, enabled) {
		var text = this.state.text;


		if (!enabled) {
			return;
		}

		this.setState({
			dragging: i,
			startX: e.clientX,
			startY: e.clientY,
			initialX: text[i].x,
			initialY: text[i].y
		});
	};

	Intro.prototype.stopDragging = function stopDragging(i) {
		this.setState({
			dragging: null,
			startX: null,
			startY: null
		});
	};

	Intro.prototype.onDrag = function onDrag(e) {
		var _state = this.state,
		    text = _state.text,
		    dragging = _state.dragging,
		    startX = _state.startX,
		    startY = _state.startY,
		    initialX = _state.initialX,
		    initialY = _state.initialY;

		if (dragging !== null) {
			text[dragging].x = initialX + e.clientX - startX;
			text[dragging].y = initialY + e.clientY - startY;

			this.setState({
				text: text
			});
		}
	};

	Intro.prototype.render = function render() {
		var _this2 = this;

		var text = this.state.text;

		var textWithId = text.map(function (item, i) {
			return Intro__extends({}, item, { id: i });
		});

		var mobileHearts = textWithId.filter(function (_ref) {
			var isMobile = _ref.isMobile,
			    isSparkle = _ref.isSparkle;
			return isMobile && !isSparkle;
		});
		var loveHearts = textWithId.filter(function (_ref2) {
			var isMobile = _ref2.isMobile,
			    isSparkle = _ref2.isSparkle;
			return !isMobile && !isSparkle;
		});

		var mobileSparkles = textWithId.filter(function (_ref3) {
			var isMobile = _ref3.isMobile,
			    isSparkle = _ref3.isSparkle;
			return isMobile && isSparkle;
		});
		var loveSparkles = textWithId.filter(function (_ref4) {
			var isMobile = _ref4.isMobile,
			    isSparkle = _ref4.isSparkle;
			return !isMobile && isSparkle;
		});

		return Object(preact_min["h"])(
			'div',
			{ className: Intro_style_default.a.root, onMouseMove: this.onDrag },
			Object(preact_min["h"])(
				components_Container,
				null,
				Object(preact_min["h"])(
					'h1',
					null,
					Object(preact_min["h"])(
						'svg',
						{
							width: '385',
							height: '353',
							className: Intro_style_default.a.image,
							xmlns: 'http://www.w3.org/2000/svg',
							viewBox: '0 0 329 302'
						},
						_ref5,
						_ref6,
						_ref7,
						_ref8,
						_ref9,
						_ref10,
						_ref11,
						_ref12,
						_ref13,
						_ref14,
						_ref15,
						_ref16,
						_ref17,
						_ref18,
						_ref19,
						_ref20,
						_ref21,
						_ref22,
						_ref23
					)
				),
				Object(preact_min["h"])(
					'div',
					{ className: Intro_style_default.a.introText, id: 'intro' },
					_ref24,
					_ref25,
					Object(preact_min["h"])(
						'div',
						{ className: Intro_style_default.a.test },
						Object(preact_min["h"])(
							'div',
							{ className: Intro_style_default.a.mobileSparkles },
							mobileSparkles.map(function (heart) {
								return Object(preact_min["h"])(components_LoveHeart, Intro__extends({
									onMouseDown: function onMouseDown(e) {
										return _this2.startDragging(e, heart.id, !heart.isSparkle);
									},
									onMouseUp: function onMouseUp() {
										return _this2.stopDragging(heart.id);
									}
								}, heart, {
									isSmall: true
								}));
							})
						),
						Object(preact_min["h"])(
							'div',
							{ className: Intro_style_default.a.desktopSparkles },
							loveSparkles.map(function (heart) {
								return Object(preact_min["h"])(components_LoveHeart, Intro__extends({
									onMouseDown: function onMouseDown(e) {
										return _this2.startDragging(e, heart.id, !heart.isSparkle);
									},
									onMouseUp: function onMouseUp() {
										return _this2.stopDragging(heart.id);
									}
								}, heart));
							})
						)
					),
					Object(preact_min["h"])(
						'div',
						null,
						Object(preact_min["h"])(
							'div',
							{ className: Intro_style_default.a.mobileHearts },
							mobileHearts.map(function (heart) {
								return Object(preact_min["h"])(components_LoveHeart, Intro__extends({
									onMouseDown: function onMouseDown(e) {
										return _this2.startDragging(e, heart.id, !heart.isSparkle);
									},
									onMouseUp: function onMouseUp() {
										return _this2.stopDragging(heart.id);
									}
								}, heart, {
									isSmall: true
								}));
							})
						),
						Object(preact_min["h"])(
							'div',
							{ className: Intro_style_default.a.desktopHearts },
							loveHearts.map(function (heart) {
								return Object(preact_min["h"])(components_LoveHeart, Intro__extends({
									onMouseDown: function onMouseDown(e) {
										return _this2.startDragging(e, heart.id, !heart.isSparkle);
									},
									onMouseUp: function onMouseUp() {
										return _this2.stopDragging(heart.id);
									}
								}, heart));
							})
						)
					)
				)
			)
		);
	};

	return Intro;
}(preact_min["Component"]);

/* harmony default export */ var components_Intro = (Intro_Intro);
// EXTERNAL MODULE: ./components/HowWeMeet/style.css
var HowWeMeet_style = __webpack_require__("0XQZ");
var HowWeMeet_style_default = /*#__PURE__*/__webpack_require__.n(HowWeMeet_style);

// CONCATENATED MODULE: ./components/HowWeMeet/index.js


function HowWeMeet__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HowWeMeet__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HowWeMeet__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var HowWeMeet_data = [{ name: 'Work', percentage: 22 }, { name: 'Friends', percentage: 18 }, { name: 'Online dating', percentage: 13 }, { name: 'Night out', percentage: 10 }, { name: 'Social event', percentage: 8 }, { name: 'School or uni', percentage: 7 }, { name: 'Family', percentage: 6 }, { name: 'Shared hobby', percentage: 3 }, { name: 'Holiday', percentage: 2 }, { name: 'Other', percentage: 11 }];

var HowWeMeet__ref = Object(preact_min["h"])(
	'p',
	null,
	'We discovered that you\u2019re more likely to meet your partner at work than in a bar, online or even through friends.'
);

var HowWeMeet__ref2 = Object(preact_min["h"])(
	'p',
	null,
	'Here\u2019s how we meet our partners:'
);

var HowWeMeet__ref4 = Object(preact_min["h"])(components_NextArrow, { to: 'working-with-the-one-you-love' });

var HowWeMeet_HowWeMeet = function (_Component) {
	HowWeMeet__inherits(HowWeMeet, _Component);

	function HowWeMeet(props) {
		HowWeMeet__classCallCheck(this, HowWeMeet);

		var _this = HowWeMeet__possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			inView: true
		};
		return _this;
	}

	HowWeMeet.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		var threshold = 0.3;

		if (typeof window !== 'undefined') {
			this.observer = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry, i) {
					if (entry.intersectionRatio > threshold) {
						_this2.props.inViewCallback();
						_this2.setState({ inView: true });
						_this2.observer.unobserve(_this2.viz);
					} else {
						_this2.setState({ inView: false });
					}
				});
			}, {
				rootMargin: '0px',
				threshold: threshold
			});
		}
	};

	HowWeMeet.prototype.componentDidMount = function componentDidMount() {
		this.observer.observe(this.viz);
	};

	HowWeMeet.prototype.componentWillUnmount = function componentWillUnmount() {
		this.observer.unobserve(this.viz);
	};

	HowWeMeet.prototype.render = function render() {
		var _cn,
		    _this3 = this;

		var _props = this.props,
		    _props$max = _props.max,
		    max = _props$max === undefined ? 22 : _props$max,
		    _props$delay = _props.delay,
		    delay = _props$delay === undefined ? 0.1 : _props$delay;


		return Object(preact_min["h"])(
			'div',
			{ className: HowWeMeet_style_default.a.root, id: 'how-we-meet' },
			Object(preact_min["h"])(
				components_Container,
				null,
				Object(preact_min["h"])(
					'div',
					{ className: HowWeMeet_style_default.a.text },
					HowWeMeet__ref,
					HowWeMeet__ref2
				),
				Object(preact_min["h"])(
					'div',
					{ className: HowWeMeet_style_default.a.extra },
					Object(preact_min["h"])(
						'div',
						{
							className: classnames_default()(HowWeMeet_style_default.a.wrapper, (_cn = {}, _cn[HowWeMeet_style_default.a.inView] = this.state.inView, _cn)),
							ref: function ref(elem) {
								return _this3.viz = elem;
							}
						},
						HowWeMeet_data.map(function (_ref3, i) {
							var name = _ref3.name,
							    percentage = _ref3.percentage;
							return Object(preact_min["h"])(
								'div',
								{
									className: HowWeMeet_style_default.a.heart,
									style: { transitionDelay: delay * i + 's' }
								},
								Object(preact_min["h"])(
									'div',
									{ className: HowWeMeet_style_default.a.vizWrap },
									Object(preact_min["h"])(
										'div',
										{
											className: HowWeMeet_style_default.a.viz,
											style: {
												transitionDelay: delay * i + 's',
												width: Math.sqrt(percentage / max * 100 / (Math.PI + 4)) * 27 + '%'
											}
										},
										Object(preact_min["h"])('div', {
											className: HowWeMeet_style_default.a.vizInner,
											style: {
												transitionDelay: delay * i + 's'
											}
										})
									)
								),
								Object(preact_min["h"])(
									'div',
									{ className: HowWeMeet_style_default.a.labelWrap },
									Object(preact_min["h"])(
										'div',
										{
											className: HowWeMeet_style_default.a.label,
											style: {
												transitionDelay: delay * i + 0.5 + 's'
											}
										},
										Object(preact_min["h"])(
											'div',
											{ className: HowWeMeet_style_default.a.labelInner },
											Object(preact_min["h"])(
												'strong',
												null,
												percentage,
												'%'
											),
											name
										)
									)
								)
							);
						})
					)
				),
				Object(preact_min["h"])(
					'p',
					{ className: HowWeMeet_style_default.a.next },
					HowWeMeet__ref4
				)
			)
		);
	};

	return HowWeMeet;
}(preact_min["Component"]);

HowWeMeet_HowWeMeet.defaultProps = {
	inViewCallback: function inViewCallback() {}
};

/* harmony default export */ var components_HowWeMeet = (HowWeMeet_HowWeMeet);
// EXTERNAL MODULE: ./components/RomanceBreakdownViz/style.css
var RomanceBreakdownViz_style = __webpack_require__("0aRJ");
var RomanceBreakdownViz_style_default = /*#__PURE__*/__webpack_require__.n(RomanceBreakdownViz_style);

// EXTERNAL MODULE: ./components/RomanceBreakdownViz/Section/style.css
var Section_style = __webpack_require__("9rP9");
var Section_style_default = /*#__PURE__*/__webpack_require__.n(Section_style);

// CONCATENATED MODULE: ./components/RomanceBreakdownViz/Section/index.js


function Section__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Section__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Section__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Section_Section = function (_Component) {
	Section__inherits(Section, _Component);

	function Section() {
		Section__classCallCheck(this, Section);

		return Section__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Section.prototype.componentWillUnMount = function componentWillUnMount() {
		var observer = this.props.observer;

		observer.unobserve(this.elem);
	};

	Section.prototype.componentDidMount = function componentDidMount() {
		var observer = this.props.observer;

		observer.observe(this.elem);
	};

	Section.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		return nextProps.isVisible !== this.props.isVisible;
	};

	Section.prototype.render = function render() {
		var _cn,
		    _cn2,
		    _this2 = this;

		var _props = this.props,
		    copy = _props.copy,
		    id = _props.id,
		    override = _props.override,
		    isLast = _props.isLast,
		    isVisible = _props.isVisible;

		var next = isLast ? 'it-might-not-work-out' : 'section-' + (id + 1);

		var main = copy();

		return Object(preact_min["h"])(
			'div',
			{
				className: classnames_default()(Section_style_default.a.extra, (_cn = {}, _cn[Section_style_default.a.isVisible] = isVisible, _cn))
			},
			Object(preact_min["h"])(
				'div',
				{ className: Section_style_default.a.wrapper, id: 'section-' + id },
				Object(preact_min["h"])(
					'div',
					{
						className: classnames_default()(Section_style_default.a.root, (_cn2 = {}, _cn2[Section_style_default.a.override] = override, _cn2)),
						id: id,
						ref: function ref(elem) {
							return _this2.elem = elem;
						}
					},
					Object(preact_min["h"])(
						'div',
						null,
						main
					),
					Object(preact_min["h"])(
						'p',
						{ className: Section_style_default.a.next },
						Object(preact_min["h"])(components_NextArrow, { to: '' + next })
					)
				)
			)
		);
	};

	return Section;
}(preact_min["Component"]);

/* harmony default export */ var RomanceBreakdownViz_Section = (Section_Section);
// EXTERNAL MODULE: ./components/RomanceBreakdownViz/Label/style.css
var Label_style = __webpack_require__("lQbg");
var Label_style_default = /*#__PURE__*/__webpack_require__.n(Label_style);

// CONCATENATED MODULE: ./components/RomanceBreakdownViz/Label/index.js


function Label__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Label__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Label__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Label_Label = function (_Component) {
	Label__inherits(Label, _Component);

	function Label() {
		Label__classCallCheck(this, Label);

		return Label__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Label.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		return nextProps.visible !== this.props.visible;
	};

	Label.prototype.render = function render() {
		var _cn;

		var _props = this.props,
		    number = _props.number,
		    total = _props.total,
		    max = _props.max,
		    columns = _props.columns,
		    _props$offset = _props.offset,
		    offset = _props$offset === undefined ? 0 : _props$offset,
		    visible = _props.visible,
		    isSecondary = _props.isSecondary,
		    _props$isTight = _props.isTight,
		    isTight = _props$isTight === undefined ? false : _props$isTight,
		    _props$totalOffset = _props.totalOffset,
		    totalOffset = _props$totalOffset === undefined ? 0 : _props$totalOffset,
		    _props$width = _props.width,
		    width = _props$width === undefined ? 100 : _props$width,
		    _props$height = _props.height,
		    height = _props$height === undefined ? 100 : _props$height;


		var maxTotal = total || max;
		var rows = Math.ceil(max / columns);
		var colSize = width / (columns - 1);
		var rowSize = height / (rows + 1);

		var isOffsetRight = offset > max / 2;
		var offsetNum = isOffsetRight ? offset : number + offset;
		var totalOffsetNum = isOffsetRight ? totalOffset : maxTotal + totalOffset;

		// const col = Math.floor(offsetNum / columns) * colSize + colSize / 2;
		// const row = (offsetNum % columns) * rowSize + rowSize / 2;

		var row = offsetNum % columns;
		var col = Math.floor(offsetNum / columns) + (isOffsetRight ? -0.5 : 1.5);

		var percentage = Math.round(number / maxTotal * 100);

		var size = 10;

		if (maxTotal !== number) {
			var totalCol = Math.floor(totalOffsetNum / columns);
			size = Math.abs(totalCol - col) + 2;
		}

		if (maxTotal === max) {
			size = 10;
		}

		if (isTight) {
			size = 4;
		}

		return Object(preact_min["h"])(
			'div',
			{
				className: classnames_default()(Label_style_default.a.root, (_cn = {}, _cn[Label_style_default.a.offsetRight] = isOffsetRight, _cn[Label_style_default.a.visible] = visible, _cn[Label_style_default.a.isSecondary] = isSecondary, _cn)),
				style: {
					left: col * colSize + '%',
					top: row * rowSize + '%',
					height: rowSize * 3 + '%',
					width: size * colSize + '%',
					display: percentage > 0 ? 'block' : 'none'
				}
			},
			Object(preact_min["h"])(
				'span',
				{ className: Label_style_default.a.text },
				percentage,
				'%'
			)
		);
	};

	return Label;
}(preact_min["Component"]);

/* harmony default export */ var RomanceBreakdownViz_Label = (Label_Label);
// EXTERNAL MODULE: ./components/RomanceBreakdownViz/Images/style.css
var Images_style = __webpack_require__("cdmB");
var Images_style_default = /*#__PURE__*/__webpack_require__.n(Images_style);

// CONCATENATED MODULE: ./components/RomanceBreakdownViz/Images/index.js



var sizes = [{
	name: 'medium',
	size: '456w'
}, {
	name: 'large',
	size: '608w'
}, {
	name: 'xlarge',
	size: '912w'
}, {
	name: 'xxlarge',
	size: '1216w'
}];

var Images_Images = function Images(_ref) {
	var id = _ref.id,
	    isVisible = _ref.isVisible,
	    hasBeenSeen = _ref.hasBeenSeen;
	return Object(preact_min["h"])(
		'div',
		{ className: Images_style_default.a.imageWrap },
		Object(preact_min["h"])('img', {
			alt: '',
			className: Images_style_default.a.canvas,
			style: {
				opacity: isVisible ? 1 : 0
			},
			src: hasBeenSeen ? 'assets/large/section-' + id + '.png' : null,
			sizes: '(min-height: 460px) AND (min-width: 460px) 456px, (min-height: 610px) AND (min-width: 860px) 608px',
			srcset: hasBeenSeen ? sizes.map(function (_ref2) {
				var name = _ref2.name,
				    size = _ref2.size;
				return 'assets/' + name + '/section-' + id + '.png ' + size;
			}).join(', ') : null
		})
	);
};

/* harmony default export */ var RomanceBreakdownViz_Images = (Images_Images);
// CONCATENATED MODULE: ./components/RomanceBreakdownViz/index.js
var RomanceBreakdownViz__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function RomanceBreakdownViz__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RomanceBreakdownViz__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function RomanceBreakdownViz__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var RomanceBreakdownViz_supportsSticky = function supportsSticky() {
	var el = document.createElement('a');
	var style = el.style;
	style.cssText = 'position:sticky;position:-webkit-sticky;';
	return style.position.indexOf('sticky') !== -1;
};

var RomanceBreakdownViz_RomanceBreakdownViz = function (_Component) {
	RomanceBreakdownViz__inherits(RomanceBreakdownViz, _Component);

	function RomanceBreakdownViz(props) {
		RomanceBreakdownViz__classCallCheck(this, RomanceBreakdownViz);

		var _this = RomanceBreakdownViz__possibleConstructorReturn(this, _Component.call(this, props));

		_this.triggers = [];
		_this.observer = [];
		_this.state = { current: 0, seen: {} };
		_this.updateCurrent = _this.updateCurrent.bind(_this);
		return _this;
	}

	RomanceBreakdownViz.prototype.updateCurrent = function updateCurrent(entries) {
		var _this2 = this;

		entries.forEach(function (entry, i) {
			if (entry.intersectionRatio > 0.5) {
				var _extends2;

				var current = +entry.target.id;
				_this2.setState({
					current: current,
					seen: RomanceBreakdownViz__extends({}, _this2.state.seen, (_extends2 = {}, _extends2[current - 1] = true, _extends2[current] = true, _extends2[current + 1] = true, _extends2))
				});
			}
		});
	};

	RomanceBreakdownViz.prototype.componentWillMount = function componentWillMount() {
		if (typeof window !== 'undefined') {
			this.observer = new IntersectionObserver(this.updateCurrent, {
				rootMargin: '0px',
				threshold: [0, 0.5, 1]
			});

			this.setState({
				supportsSticky: RomanceBreakdownViz_supportsSticky()
			});
		}
	};

	RomanceBreakdownViz.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
		return nextState.current !== this.state.current || nextState.seen !== this.state.seen || nextProps.loaded !== this.props.loaded;
	};

	RomanceBreakdownViz.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
		if (!this.props.loaded && nextProps.loaded) {
			this.setState({
				seen: RomanceBreakdownViz__extends({}, this.state.seen, {
					0: true,
					1: true
				})
			});
		}
	};

	RomanceBreakdownViz.prototype.render = function render() {
		var _props = this.props,
		    sections = _props.sections,
		    data = _props.data;
		var _state = this.state,
		    current = _state.current,
		    seen = _state.seen,
		    supportsSticky = _state.supportsSticky;

		var columns = 77;
		var max = 5795;

		return Object(preact_min["h"])(
			'div',
			{ className: classnames_default()(RomanceBreakdownViz_style_default.a.root), 'data-supports-sticky': !supportsSticky },
			Object(preact_min["h"])(
				components_Container,
				null,
				Object(preact_min["h"])(
					'div',
					{ className: RomanceBreakdownViz_style_default.a.extra },
					Object(preact_min["h"])(
						'div',
						{ className: RomanceBreakdownViz_style_default.a.viz, id: 'working-with-the-one-you-love' },
						Object(preact_min["h"])(
							'div',
							{ className: RomanceBreakdownViz_style_default.a.vizInner },
							Object(preact_min["h"])(
								'div',
								{ className: RomanceBreakdownViz_style_default.a.wrap },
								sections.map(function (section, i) {
									return Object(preact_min["h"])(
										'div',
										{ className: RomanceBreakdownViz_style_default.a.ieWrap },
										Object(preact_min["h"])(
											'div',
											{ className: RomanceBreakdownViz_style_default.a.imageSizer },
											Object(preact_min["h"])(
												'div',
												{ className: RomanceBreakdownViz_style_default.a.imageWrap },
												(i === current - 1 || i === current || i === current + 1) && Object(preact_min["h"])(RomanceBreakdownViz_Images, {
													id: i,
													isVisible: i <= current,
													hasBeenSeen: seen[i]
												}),
												data[i].groups.map(function (group, j) {
													return Object(preact_min["h"])(
														'div',
														{ className: RomanceBreakdownViz_style_default.a.labelSizer },
														Object(preact_min["h"])(RomanceBreakdownViz_Label, RomanceBreakdownViz__extends({
															id: i
														}, group, {
															columns: columns,
															max: max,
															visible: current === i,
															isTight: data[i].groups.length > 1,
															isSecondary: j > 0
														}))
													);
												})
											)
										)
									);
								})
							)
						)
					)
				),
				Object(preact_min["h"])(RomanceBreakdownViz_Sections, {
					sections: sections,
					observer: this.observer,
					current: current,
					supportsSticky: supportsSticky
				})
			)
		);
	};

	return RomanceBreakdownViz;
}(preact_min["Component"]);

var RomanceBreakdownViz_Sections = function (_Component2) {
	RomanceBreakdownViz__inherits(Sections, _Component2);

	function Sections() {
		RomanceBreakdownViz__classCallCheck(this, Sections);

		return RomanceBreakdownViz__possibleConstructorReturn(this, _Component2.apply(this, arguments));
	}

	Sections.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		return this.props.current !== nextProps.current;
	};

	Sections.prototype.render = function render() {
		var _props2 = this.props,
		    sections = _props2.sections,
		    observer = _props2.observer,
		    current = _props2.current;

		return Object(preact_min["h"])(
			'div',
			{ className: RomanceBreakdownViz_style_default.a.sections },
			sections.map(function (section, i) {
				return Object(preact_min["h"])(RomanceBreakdownViz_Section, RomanceBreakdownViz__extends({
					id: i
				}, section, {
					observer: observer,
					isLast: i === sections.length - 1,
					isVisible: current === i
				}));
			})
		);
	};

	return Sections;
}(preact_min["Component"]);

/* harmony default export */ var components_RomanceBreakdownViz = (RomanceBreakdownViz_RomanceBreakdownViz);
// EXTERNAL MODULE: ./components/BreakupMosaic/style.css
var BreakupMosaic_style = __webpack_require__("tNlp");
var BreakupMosaic_style_default = /*#__PURE__*/__webpack_require__.n(BreakupMosaic_style);

// CONCATENATED MODULE: ./components/BreakupMosaic/index.js


function BreakupMosaic__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BreakupMosaic__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BreakupMosaic__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var reasons = [{ reason: 'Lost interest', size: 'small', style: 2 }, {
	reason: 'People trying to cause trouble with lies',
	size: 'medium',
	style: 1
}, { reason: 'She was married to a colleague', size: 'medium', style: 3 }, { reason: 'He got a new one', size: 'small', style: 4 }, { reason: 'Drifted apart', size: 'small', style: 1 }, { reason: 'Had to move to a different country', size: 'medium', style: 2 }, { reason: 'Found out he was married', size: 'medium', style: 4 }, { reason: 'She found someone else', size: 'small', style: 3 }, { reason: 'Disconnect of ambition', size: 'small', style: 2 }];

var BreakupMosaic_styles = [{ border: '#FECA98', fill: '#FFF2E6' }, { border: '#F1979A', fill: '#F6C1C2' }, { border: '#D8AC24', fill: '#FEE077' }, { border: '#709EEB', fill: '#C2D6F7' }];

var BreakupMosaic_BreakupMosaic = function (_Component) {
	BreakupMosaic__inherits(BreakupMosaic, _Component);

	function BreakupMosaic(props) {
		BreakupMosaic__classCallCheck(this, BreakupMosaic);

		var _this = BreakupMosaic__possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			inView: true
		};
		return _this;
	}

	BreakupMosaic.prototype.componentWillMount = function componentWillMount() {
		var _this2 = this;

		var threshold = 0.3;

		if (typeof window !== 'undefined') {
			this.observer = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry, i) {
					if (entry.intersectionRatio > threshold) {
						_this2.setState({ inView: true });
						_this2.observer.unobserve(_this2.viz);
					} else {
						_this2.setState({ inView: false });
					}
				});
			}, {
				rootMargin: '0px',
				threshold: threshold
			});
		}
	};

	BreakupMosaic.prototype.componentDidMount = function componentDidMount() {
		this.observer.observe(this.viz);
	};

	BreakupMosaic.prototype.componentWillUnmount = function componentWillUnmount() {
		this.observer.unobserve(this.viz);
	};

	BreakupMosaic.prototype.render = function render() {
		var _cn,
		    _this3 = this;

		var inView = this.state.inView;


		return Object(preact_min["h"])(
			'div',
			{
				className: classnames_default()(BreakupMosaic_style_default.a.root, (_cn = {}, _cn[BreakupMosaic_style_default.a.inView] = inView, _cn)),
				id: 'it-might-not-work-out'
			},
			Object(preact_min["h"])(
				components_Container,
				null,
				Object(preact_min["h"])(
					'p',
					{ className: BreakupMosaic_style_default.a.text },
					'Here are some of the many different reasons you gave for calling it quits with a work mate.'
				),
				Object(preact_min["h"])(
					'div',
					{ className: BreakupMosaic_style_default.a.reasonsWrap },
					Object(preact_min["h"])(
						'ul',
						{ className: BreakupMosaic_style_default.a.reasons, ref: function ref(elem) {
								return _this3.viz = elem;
							} },
						reasons.map(function (_ref, i) {
							var _cn2, _cn3;

							var reason = _ref.reason,
							    size = _ref.size,
							    style = _ref.style;
							return Object(preact_min["h"])(
								'li',
								{
									className: classnames_default()(BreakupMosaic_style_default.a.heart, (_cn2 = {}, _cn2[BreakupMosaic_style_default.a[size]] = true, _cn2), (_cn3 = {}, _cn3[BreakupMosaic_style_default.a['style-' + style]] = true, _cn3)),
									style: {
										transitionDelay: i * 0.2 + 's'
									}
								},
								Object(preact_min["h"])(
									'svg',
									{ className: BreakupMosaic_style_default.a.bg, viewBox: '0 0 70 70' },
									Object(preact_min["h"])('use', {
										xlinkHref: '#heart',
										style: {
											fill: BreakupMosaic_styles[style - 1].fill,
											color: BreakupMosaic_styles[style - 1].border
										}
									})
								),
								Object(preact_min["h"])(
									'span',
									null,
									'"',
									reason,
									'"'
								)
							);
						})
					)
				)
			)
		);
	};

	return BreakupMosaic;
}(preact_min["Component"]);

/* harmony default export */ var components_BreakupMosaic = (BreakupMosaic_BreakupMosaic);
// EXTERNAL MODULE: ./components/RelatedContent/style.css
var RelatedContent_style = __webpack_require__("iOXE");
var RelatedContent_style_default = /*#__PURE__*/__webpack_require__.n(RelatedContent_style);

// CONCATENATED MODULE: ./components/RelatedContent/index.js





var related = [{
	name: 'The World of Work Spouses',
	desc: 'We all have that one colleague who makes work more bearable.',
	image: 'assets/the-world-of-work-spouses.svg',
	url: 'https://www.totaljobs.com/insidejob/work-spouse/'
}, {
	name: 'Superflexibility',
	desc: 'How the modern workforce is changing the rules of work-life balance.',
	image: 'assets/superflexability.jpg',
	url: 'https://www.totaljobs.com/insidejob/work-life-balance/'
}];

var RelatedContent_RelatedContent = function RelatedContent(_ref) {
	var loaded = _ref.loaded;
	return Object(preact_min["h"])(
		'div',
		{ className: RelatedContent_style_default.a.root },
		Object(preact_min["h"])(
			components_Container,
			null,
			Object(preact_min["h"])(
				'h2',
				{ className: RelatedContent_style_default.a.title },
				'Keep exploring your\xA0work-self'
			),
			Object(preact_min["h"])(
				'div',
				{ className: RelatedContent_style_default.a.related },
				related.map(function (_ref2) {
					var name = _ref2.name,
					    desc = _ref2.desc,
					    image = _ref2.image,
					    url = _ref2.url;
					return Object(preact_min["h"])(
						'a',
						{ href: url, target: '_blank', rel: 'noopener', className: RelatedContent_style_default.a.article },
						Object(preact_min["h"])('span', {
							className: RelatedContent_style_default.a.image,
							style: {
								backgroundImage: loaded ? 'url(' + image + ')' : 'none'
							}
						}),
						Object(preact_min["h"])(
							'h3',
							{ className: RelatedContent_style_default.a.name },
							Object(preact_min["h"])(
								'span',
								null,
								name
							)
						),
						Object(preact_min["h"])(
							'p',
							{ classNAme: RelatedContent_style_default.a.desc },
							desc
						)
					);
				})
			)
		)
	);
};

/* harmony default export */ var components_RelatedContent = (RelatedContent_RelatedContent);
// EXTERNAL MODULE: ./components/SVGs/style.css
var SVGs_style = __webpack_require__("eP7G");
var SVGs_style_default = /*#__PURE__*/__webpack_require__.n(SVGs_style);

// CONCATENATED MODULE: ./components/SVGs/index.js



var SVGs__ref = Object(preact_min["h"])(
	'svg',
	{
		xmlns: 'http://www.w3.org/2000/svg',
		width: '16',
		height: '16',
		viewBox: '0 0 8 8'
	},
	Object(preact_min["h"])('path', {
		id: 'sparkle',
		d: 'M4 8c0-2.211-1.789-4-4-4 2.211 0 4-1.789 4-4 0 2.211 1.789 4 4 4-2.211 0-4 1.789-4 4',
		fill: '#D4F4E8',
		'fill-rule': 'evenodd'
	})
);

var SVGs__ref2 = Object(preact_min["h"])(
	'g',
	{ 'fill-rule': 'evenodd', id: 'heart' },
	Object(preact_min["h"])('path', {
		d: 'M69.6667 35.8333c0 18.6858-15.1478 33.8334-33.8334 33.8334C17.1475 69.6667 2 54.519 2 35.8333 2 17.1478 17.1475 2 35.8333 2 54.519 2 69.6667 17.1478 69.6667 35.8333',
		fill: 'currentColor'
	}),
	Object(preact_min["h"])('path', {
		d: 'M67.6667 33.8333c0 18.6856-15.1476 33.8334-33.8334 33.8334C15.1478 67.6667 0 52.5189 0 33.8333 0 15.1475 15.1478 0 33.8333 0c18.6858 0 33.8334 15.1475 33.8334 33.8333',
		fill: 'inherit'
	}),
	Object(preact_min["h"])('path', {
		d: 'M58.6387 17.331c-6.155-6.7016-16.577-7.1446-23.2783-.9897a.7498.7498 0 0 1-.0148.0135c-.7707.7099-1.9404.7099-2.7112 0a.7501.7501 0 0 1-.0147-.0135c-6.7014-6.155-17.1234-5.7119-23.2786.9897-6.1546 6.7014-5.7116 17.1236.9897 23.2783l21.6917 21.0498c1.096 1.0634 2.839 1.0634 3.935 0L57.649 40.6093c6.7016-6.1547 7.1446-16.577.9897-23.2783z',
		stroke: '#E74347',
		'stroke-linejoin': 'round'
	})
);

var SVGs_SVGs = function SVGs() {
	return Object(preact_min["h"])(
		'div',
		{
			style: {
				display: 'none'
			}
		},
		SVGs__ref,
		Object(preact_min["h"])(
			'svg',
			{
				className: SVGs_style_default.a.heart,
				width: '70',
				height: '70',
				xmlns: 'http://www.w3.org/2000/svg'
			},
			SVGs__ref2
		)
	);
};

/* harmony default export */ var components_SVGs = (SVGs_SVGs);
// CONCATENATED MODULE: ./data/sections.js


var sections__ref = Object(preact_min["h"])(
	'p',
	null,
	'But how easy is it to work with the one you love? Here\u2019s what',
	' ',
	Object(preact_min["h"])(
		'em',
		null,
		'5,795'
	),
	' UK workers had to say about romance in the workplace.'
);

var sections__ref2 = Object(preact_min["h"])(
	'p',
	null,
	'It turns out 2 in 3 ',
	Object(preact_min["h"])(
		'em',
		null,
		'UK workers'
	),
	' are',
	' ',
	Object(preact_min["h"])(
		'strong',
		null,
		'up for dating a colleague'
	),
	'.'
);

var sections__ref3 = Object(preact_min["h"])(
	'p',
	null,
	'Leaving 1 in 3 ',
	Object(preact_min["h"])(
		'em',
		null,
		'workers'
	),
	' who',
	' ',
	Object(preact_min["h"])(
		'strong',
		null,
		'would never date someone at work'
	),
	'.'
);

var sections__ref4 = Object(preact_min["h"])(
	'p',
	null,
	'The main reason these ',
	Object(preact_min["h"])(
		'em',
		null,
		'cautious folks'
	),
	' wouldn\u2019t date a colleague? They just ',
	Object(preact_min["h"])(
		'strong',
		null,
		'don\u2019t think romance and work mix'
	),
	'.'
);

var sections__ref5 = Object(preact_min["h"])(
	'p',
	null,
	'If you\u2019re looking for love at work, your best bet is to apply for a job in the ',
	Object(preact_min["h"])(
		'em',
		null,
		'leisure industry'
	),
	'. You\u2019ll find most people are',
	' ',
	Object(preact_min["h"])(
		'strong',
		null,
		'open to dating a colleague'
	),
	'.'
);

var sections__ref6 = Object(preact_min["h"])(
	'p',
	null,
	'Best to avoid ',
	Object(preact_min["h"])(
		'em',
		null,
		'manufacturing'
	),
	', though \u2013 your co-workers are likely to be ',
	Object(preact_min["h"])(
		'strong',
		null,
		'less enthusiastic'
	),
	'.'
);

var sections__ref7 = Object(preact_min["h"])(
	'div',
	null,
	Object(preact_min["h"])(
		'p',
		null,
		'Don\u2019t worry if this is all news to you.'
	),
	Object(preact_min["h"])(
		'p',
		null,
		'It seems we don\'t like discussing our workplace romances.',
		' ',
		Object(preact_min["h"])(
			'em',
			null,
			'Dating colleagues'
		),
		' tend to keep their relationship',
		' ',
		Object(preact_min["h"])(
			'strong',
			null,
			'hush-hush'
		),
		'.'
	)
);

var sections__ref8 = Object(preact_min["h"])(
	'p',
	null,
	'Although a noble few ',
	Object(preact_min["h"])(
		'em',
		null,
		'dating colleagues'
	),
	' remain ever the professionals and ',
	Object(preact_min["h"])(
		'strong',
		null,
		'go straight to HR'
	),
	'.'
);

var sections__ref9 = Object(preact_min["h"])(
	'div',
	null,
	Object(preact_min["h"])(
		'p',
		null,
		'But what is it really like to date someone you work with?'
	),
	Object(preact_min["h"])(
		'p',
		null,
		Object(preact_min["h"])(
			'em',
			null,
			'Colleague couples'
		),
		' admitted feeling the need to',
		' ',
		Object(preact_min["h"])(
			'strong',
			null,
			'act more professionally'
		),
		'.'
	)
);

var sections__ref10 = Object(preact_min["h"])(
	'p',
	null,
	Object(preact_min["h"])(
		'em',
		null,
		'Colleague couples'
	),
	' also confirmed that',
	' ',
	Object(preact_min["h"])(
		'strong',
		null,
		'gossip in the workplace'
	),
	' added pressure to the relationship.'
);

var sections__ref11 = Object(preact_min["h"])(
	'p',
	null,
	'And we found that those ',
	Object(preact_min["h"])(
		'em',
		null,
		'living in London'
	),
	' were even more likely to feel the ',
	Object(preact_min["h"])(
		'strong',
		null,
		'pressure of gossip'
	),
	'.'
);

var sections__ref12 = Object(preact_min["h"])(
	'p',
	null,
	'But there\u2019s good news, too. If you\u2019re ',
	Object(preact_min["h"])(
		'em',
		null,
		'dating a colleague'
	),
	', the chances are your ',
	Object(preact_min["h"])(
		'strong',
		null,
		'career progression'
	),
	' won\'t come into question.'
);

var sections__ref13 = Object(preact_min["h"])(
	'p',
	null,
	'You won\'t find it any more difficult to ',
	Object(preact_min["h"])(
		'strong',
		null,
		'plan holidays'
	),
	'.'
);

var sections__ref14 = Object(preact_min["h"])(
	'p',
	null,
	'And you\'ll still get that precious ',
	Object(preact_min["h"])(
		'strong',
		null,
		'\'me time\''
	),
	'.'
);

var sections__ref15 = Object(preact_min["h"])(
	'div',
	null,
	Object(preact_min["h"])(
		'p',
		null,
		'So what\'s the worst that can happen when you ',
		Object(preact_min["h"])(
			'em',
			null,
			'date a colleague'
		),
		'?'
	),
	Object(preact_min["h"])(
		'p',
		null,
		'1 in 3 feel ',
		Object(preact_min["h"])(
			'strong',
			null,
			'judged'
		),
		' by their co-workers.'
	)
);

var sections__ref16 = Object(preact_min["h"])(
	'p',
	null,
	'1 in 4 experience ',
	Object(preact_min["h"])(
		'strong',
		null,
		'jealousy'
	),
	'.'
);

var sections__ref17 = Object(preact_min["h"])(
	'p',
	null,
	'1 in 6 get ',
	Object(preact_min["h"])(
		'strong',
		null,
		'made fun of'
	),
	'.'
);

var sections__ref18 = Object(preact_min["h"])(
	'p',
	null,
	'And 1 in 10 felt they were ',
	Object(preact_min["h"])(
		'strong',
		null,
		'discriminated against'
	),
	' ',
	'because of their workplace romance.'
);

var sections__ref19 = Object(preact_min["h"])(
	'div',
	null,
	Object(preact_min["h"])(
		'p',
		null,
		'Not everyone\u2019s experience will be the same.'
	),
	Object(preact_min["h"])(
		'p',
		null,
		'If you\'re a ',
		Object(preact_min["h"])(
			'em',
			null,
			'woman dating your manager'
		),
		', your career is more likely to take a hit than a ',
		Object(preact_min["h"])(
			'em',
			null,
			'man dating their manager'
		),
		' when it comes to...'
	)
);

var sections__ref20 = Object(preact_min["h"])(
	'p',
	null,
	Object(preact_min["h"])(
		'strong',
		null,
		'your'
	),
	' promotion opportunities,'
);

var sections__ref21 = Object(preact_min["h"])(
	'p',
	null,
	Object(preact_min["h"])(
		'strong',
		null,
		'your'
	),
	' salary and bonus opportunities,'
);

var sections__ref22 = Object(preact_min["h"])(
	'p',
	null,
	Object(preact_min["h"])(
		'strong',
		null,
		'your'
	),
	' relationships with colleagues,'
);

var sections__ref23 = Object(preact_min["h"])(
	'p',
	null,
	'and ',
	Object(preact_min["h"])(
		'strong',
		null,
		'your'
	),
	' relationships with managers.'
);

var sections__ref24 = Object(preact_min["h"])(
	'div',
	null,
	Object(preact_min["h"])(
		'p',
		null,
		'Then there\u2019s the fact that things might not (ahem) work out.'
	),
	' ',
	Object(preact_min["h"])(
		'p',
		null,
		'1 in 3 ',
		Object(preact_min["h"])(
			'em',
			null,
			'UK workers'
		),
		' think breaking up with a colleague would',
		' ',
		Object(preact_min["h"])(
			'strong',
			null,
			'negatively affect workplace dynamics'
		),
		'.'
	)
);

var sections__ref25 = Object(preact_min["h"])(
	'p',
	null,
	'But only 1 in 7 ',
	Object(preact_min["h"])(
		'em',
		null,
		'UK workers'
	),
	' would',
	' ',
	Object(preact_min["h"])(
		'strong',
		null,
		'quit their job'
	),
	' because of it.'
);

var _ref26 = Object(preact_min["h"])(
	'div',
	null,
	Object(preact_min["h"])(
		'p',
		null,
		'A risk that seems to gradually reduce the further north you live.'
	),
	' ',
	Object(preact_min["h"])(
		'p',
		null,
		'These ',
		Object(preact_min["h"])(
			'em',
			null,
			'northerners'
		),
		' would ',
		Object(preact_min["h"])(
			'strong',
			null,
			'quit their job'
		),
		' if the relationship ended.'
	)
);

var _ref27 = Object(preact_min["h"])(
	'p',
	null,
	'Fewer than the ',
	Object(preact_min["h"])(
		'em',
		null,
		'southerners'
	),
	' who would',
	' ',
	Object(preact_min["h"])(
		'strong',
		null,
		'quit their job'
	),
	' if the relationship ended.'
);

var _ref28 = Object(preact_min["h"])(
	'div',
	null,
	Object(preact_min["h"])(
		'p',
		null,
		'There are plenty of reasons why a relationship at work might not last.'
	),
	' ',
	Object(preact_min["h"])(
		'p',
		null,
		'On the ',
		Object(preact_min["h"])(
			'em',
			null,
			'relationships that ended'
		),
		', many said that',
		' ',
		Object(preact_min["h"])(
			'strong',
			null,
			'working together killed the romance'
		),
		'.'
	)
);

var _ref29 = Object(preact_min["h"])(
	'p',
	null,
	'Others found ',
	Object(preact_min["h"])(
		'strong',
		null,
		'their relationship got in the way of work'
	),
	' ',
	'\u2013 and chose the latter.'
);

var _ref30 = Object(preact_min["h"])(
	'p',
	null,
	'But as with any relationship, sometimes',
	' ',
	Object(preact_min["h"])(
		'strong',
		null,
		'it\'s just not meant to be'
	),
	'.'
);

/* harmony default export */ var data_sections = ([{
	copy: function copy() {
		return sections__ref;
	}
}, {
	copy: function copy() {
		return sections__ref2;
	}
}, {
	copy: function copy() {
		return sections__ref3;
	}
}, {
	copy: function copy() {
		return sections__ref4;
	}
}, {
	copy: function copy() {
		return sections__ref5;
	}
}, {
	copy: function copy() {
		return sections__ref6;
	}
}, {
	copy: function copy() {
		return sections__ref7;
	}
}, {
	copy: function copy() {
		return sections__ref8;
	}
}, {
	copy: function copy() {
		return sections__ref9;
	}
}, {
	copy: function copy() {
		return sections__ref10;
	}
}, {
	copy: function copy() {
		return sections__ref11;
	}
}, {
	copy: function copy() {
		return sections__ref12;
	}
}, {
	copy: function copy() {
		return sections__ref13;
	}
}, {
	copy: function copy() {
		return sections__ref14;
	}
}, {
	copy: function copy() {
		return sections__ref15;
	}
}, {
	copy: function copy() {
		return sections__ref16;
	}
}, {
	copy: function copy() {
		return sections__ref17;
	}
}, {
	copy: function copy() {
		return sections__ref18;
	}
}, {
	copy: function copy() {
		return sections__ref19;
	}
}, {
	copy: function copy() {
		return sections__ref20;
	}
}, {
	copy: function copy() {
		return sections__ref21;
	}
}, {
	copy: function copy() {
		return sections__ref22;
	}
}, {
	copy: function copy() {
		return sections__ref23;
	}
}, {
	copy: function copy() {
		return sections__ref24;
	}
}, {
	copy: function copy() {
		return sections__ref25;
	}
}, {
	copy: function copy() {
		return _ref26;
	}
}, {
	copy: function copy() {
		return _ref27;
	},
	override: true
}, {
	copy: function copy() {
		return _ref28;
	}
}, {
	copy: function copy() {
		return _ref29;
	}
}, {
	copy: function copy() {
		return _ref30;
	}
}]);
// EXTERNAL MODULE: ./data/data.json
var data_data = __webpack_require__("tq1P");
var data_default = /*#__PURE__*/__webpack_require__.n(data_data);

// CONCATENATED MODULE: ./index.js


function index__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function index__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function index__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














if (typeof window !== 'undefined') {
	smoothscroll_default.a.polyfill();

	if (!('IntersectionObserver' in window) && !('IntersectionObserverEntry' in window) && !(window.IntersectionObserverEntry && 'intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
		__webpack_require__("GkNt");
	}

	window.onbeforeunload = function () {
		window.scrollTo(0, 0);
	};
}

if (false) {
	require('preact/debug');
}

var index__ref = Object(preact_min["h"])(components_SVGs, null);

var index__ref2 = Object(preact_min["h"])(components_Intro, null);

var index__ref3 = Object(preact_min["h"])(components_BreakupMosaic, null);

var index_Site = function (_Component) {
	index__inherits(Site, _Component);

	Site.prototype.lazyLoad = function lazyLoad() {
		this.setState({ hasScrolled: true });
	};

	function Site(props) {
		index__classCallCheck(this, Site);

		var _this = index__possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = { hasScrolled: false };
		_this.lazyLoad = _this.lazyLoad.bind(_this);
		return _this;
	}

	Site.prototype.render = function render() {
		var hasScrolled = this.state.hasScrolled;


		return Object(preact_min["h"])(
			layouts_main,
			null,
			index__ref,
			index__ref2,
			Object(preact_min["h"])(components_HowWeMeet, { inViewCallback: this.lazyLoad }),
			Object(preact_min["h"])(components_RomanceBreakdownViz, {
				sections: data_sections,
				data: data_default.a,
				loaded: hasScrolled
			}),
			index__ref3,
			Object(preact_min["h"])(components_RelatedContent, { loaded: hasScrolled })
		);
	};

	return Site;
}(preact_min["Component"]);

/* harmony default export */ var index = __webpack_exports__["default"] = (index_Site);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink\:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "LTbr":
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.0 - 2018 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill

  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if ('scrollBehavior' in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (firstArg === null || typeof firstArg !== 'object' || firstArg.behavior === undefined || firstArg.behavior === 'auto' || firstArg.behavior === 'instant') {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError('behavior member of ScrollOptions ' + firstArg.behavior + ' is not a valid value for enumeration ScrollBehavior.');
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      var isBody;

      do {
        el = el.parentNode;

        isBody = el === d.body;
      } while (isBody === false && isScrollable(el) === false);

      isBody = null;

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function () {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== 'object' ? arguments[0] : w.scrollX || w.pageXOffset,
        // use top prop, second argument if present or fallback to scrollY
        arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
    };

    // w.scrollBy
    w.scrollBy = function () {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== 'object' ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function () {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(this,
        // use left prop, first number argument or fallback to scrollLeft
        arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
        // use top prop, second argument or fallback to scrollTop
        arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(this, this, typeof left === 'undefined' ? this.scrollLeft : ~~left, typeof top === 'undefined' ? this.scrollTop : ~~top);
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function () {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function () {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }
})();

/***/ }),

/***/ "cdmB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"canvas":"canvas__1A9rB"};

/***/ }),

/***/ "eP7G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"heart":"heart__35S46"};

/***/ }),

/***/ "h0Qy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logo":"logo__1WUr8","trim":"trim__10ZUh"};

/***/ }),

/***/ "iOXE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__PqsSH","title":"title__1Y1VF","related":"related__1Yq4s","article":"article__3zmHB","name":"name__2aEAs","image":"image__16Nfu"};

/***/ }),

/***/ "l8Hw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__3pe1G","introText":"introText__2qLz_","image":"image__3Haqt","mobileHearts":"mobileHearts__2IGyq","mobileSparkles":"mobileSparkles__7zz1i","desktopHearts":"desktopHearts__3aGKl","desktopSparkles":"desktopSparkles__241q1"};

/***/ }),

/***/ "lQbg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__r-j5D","isSecondary":"isSecondary__3TIvu","visible":"visible__jtFOo","text":"text__1daKk","offsetRight":"offsetRight__20sj8"};

/***/ }),

/***/ "n4o+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__27nIa","logo":"logo__3txfA"};

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "tNlp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"root__3P9NT","text":"text__3oB9X","reasonsWrap":"reasonsWrap__2zMeC","reasons":"reasons__3dgvc","heart":"heart__3A_2f","inView":"inView__1LH6w","bg":"bg__Wbdpq","medium":"medium__2ddqE","large":"large__2L4e2"};

/***/ }),

/***/ "tq1P":
/***/ (function(module, exports) {

module.exports = [{"groups":[{"number":0}]},{"groups":[{"number":3843}]},{"groups":[{"number":1952,"offset":3843}]},{"groups":[{"total":1893,"number":940,"offset":4855,"totalOffset":3902}]},{"groups":[{"total":172,"number":138}]},{"groups":[{"total":303,"number":114,"offset":5681,"totalOffset":5492}]},{"groups":[{"total":2292,"number":1740}]},{"groups":[{"total":2292,"number":70,"offset":2222,"totalOffset":0}]},{"groups":[{"total":2499,"number":1487}]},{"groups":[{"total":2499,"number":1274}]},{"groups":[{"total":345,"number":205}]},{"groups":[{"total":2499,"number":1777,"offset":722}]},{"groups":[{"total":2499,"number":1474,"offset":1025}]},{"groups":[{"total":2499,"number":1612,"offset":887}]},{"groups":[{"total":2495,"number":776}]},{"groups":[{"total":2495,"number":619,"offset":776}]},{"groups":[{"total":2495,"number":418,"offset":1395}]},{"groups":[{"total":2495,"number":265,"offset":1813}]},{"groups":[{"number":0,"total":98},{"number":0,"total":60,"color":"#17ada1","fadedColor":"#b2e3de","offset":1232,"totalOffset":1232}]},{"groups":[{"number":29,"total":98},{"number":13,"total":60,"color":"#17ada1","fadedColor":"#b2e3de","offset":1232,"totalOffset":1232}]},{"groups":[{"number":20,"total":98},{"number":7,"total":60,"color":"#17ada1","fadedColor":"#b2e3de","offset":1232,"totalOffset":1232}]},{"groups":[{"number":41,"total":98},{"number":15,"total":60,"color":"#17ada1","fadedColor":"#b2e3de","offset":1232,"totalOffset":1232}]},{"groups":[{"number":25,"total":98},{"number":12,"total":60,"color":"#17ada1","fadedColor":"#b2e3de","offset":1232,"totalOffset":1232}]},{"groups":[{"number":2008}]},{"groups":[{"number":834}]},{"groups":[{"total":1828,"number":235}]},{"override":true,"groups":[{"total":1828,"number":235},{"total":2532,"number":400,"offset":1828,"totalOffset":1828,"color":"#17ada1","fadedColor":"#b2e3de"}]},{"groups":[{"total":395,"number":173}]},{"groups":[{"total":395,"number":145,"offset":173}]},{"groups":[{"total":395,"number":59,"offset":318}]}]

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.eda69.js